{
  "about.blocks": "Modereeritavad serverid",
  "about.contact": "Kontakt:",
  "about.default_locale": "Vaikimisi",
  "about.disclaimer": "Mastodon on vaba, tasuta ja avatud lähtekoodiga tarkvara ning Mastodon gGmbH kaubamärk.",
  "about.domain_blocks.no_reason_available": "Põhjus on teadmata",
  "about.domain_blocks.preamble": "Mastodon lubab üldiselt vaadata sisu ning suhelda kasutajatega ükskõik millisest teisest födiversumi serverist. Need on erandid, mis kehtivad selles kindlas serveris.",
  "about.domain_blocks.silenced.explanation": "Sa üldjuhul ei näe profiile ja sisu sellest serverist, kui sa just tahtlikult neid ei otsi või jälgimise moel nõusolekut ei anna.",
  "about.domain_blocks.silenced.title": "Piiratud",
  "about.domain_blocks.suspended.explanation": "Mitte mingeid andmeid sellelt serverilt ei töödelda, salvestata ega vahetata, tehes igasuguse suhestumise või infovahetuse selle serveri kasutajatega võimatuks.",
  "about.domain_blocks.suspended.title": "Peatatud",
  "about.language_label": "Keel",
  "about.not_available": "See info ei ole selles serveris saadavaks tehtud.",
  "about.powered_by": "Hajutatud sotsiaalmeedia, mille taga on {mastodon}",
  "about.rules": "Serveri reeglid",
  "account.account_note_header": "Isiklik märge",
  "account.activity": "Tegevus",
  "account.add_note": "Lisa isiklik märge",
  "account.add_or_remove_from_list": "Lisa või eemalda loenditest",
  "account.badges.admin": "Peakasutaja",
  "account.badges.blocked": "Blokeeritud",
  "account.badges.bot": "Robot",
  "account.badges.domain_blocked": "Blokeeritud domeen",
  "account.badges.group": "Grupp",
  "account.badges.muted": "Summutatud",
  "account.badges.muted_until": "Summutatud kuni {until}",
  "account.block": "Blokeeri @{name}",
  "account.block_domain": "Blokeeri kõik domeenist {domain}",
  "account.block_short": "Blokeeri",
  "account.blocked": "Blokeeritud",
  "account.cancel_follow_request": "Võta jälgimissoov tagasi",
  "account.copy": "Kopeeri profiili link",
  "account.direct": "Maini privaatselt kasutajat @{name}",
  "account.disable_notifications": "Ära teavita, kui @{name} postitab",
  "account.edit_note": "Muuda isiklikku märget",
  "account.edit_profile": "Muuda profiili",
  "account.edit_profile_short": "Muuda",
  "account.enable_notifications": "Teavita mind, kui {name} postitab",
  "account.endorse": "Too profiilis esile",
  "account.familiar_followers_many": "Jälgijateks {name1}, {name2} ja veel {othersCount, plural, one {üks kasutaja, keda tead} other {# kasutajat, keda tead}}",
  "account.familiar_followers_one": "Jälgijaks {name1}",
  "account.familiar_followers_two": "Jälgijateks {name1} ja {name2}",
  "account.featured": "Esiletõstetud",
  "account.featured.accounts": "Profiilid",
  "account.featured.collections": "Kogumikud",
  "account.featured.new_collection": "Uus kogumik",
  "account.field_overflow": "Näita kogu sisu",
  "account.filters.all": "Kõik tegevused",
  "account.filters.boosts_toggle": "Näita hooandmisi",
  "account.filters.posts_boosts": "Postitused ja hooandmised",
  "account.filters.posts_only": "Postitused",
  "account.filters.posts_replies": "Postitused ja vastused",
  "account.filters.replies_toggle": "Näita vastuseid",
  "account.follow": "Jälgi",
  "account.follow_back": "Jälgi vastu",
  "account.follow_back_short": "Jälgi vastu",
  "account.follow_request": "Jälgimispäring",
  "account.follow_request_cancel": "Tühista päring",
  "account.follow_request_cancel_short": "Katkesta",
  "account.follow_request_short": "Koosta päring",
  "account.followers": "Jälgijad",
  "account.followers.empty": "Keegi ei jälgi veel seda kasutajat.",
  "account.followers_counter": "{count, plural, one {{counter} jälgija} other {{counter} jälgijat}}",
  "account.followers_you_know_counter": "{counter} kasutaja(t), keda sa tead",
  "account.following": "Jälgib",
  "account.following_counter": "{count, plural, one {{counter} jälgib} other {{counter} jälgib}}",
  "account.follows.empty": "See kasutaja ei jälgi veel mitte kedagi.",
  "account.follows_you": "Jälgib sind",
  "account.go_to_profile": "Vaata profiili",
  "account.hide_reblogs": "Peida kasutaja @{name} hooandmised",
  "account.in_memoriam": "In Memoriam.",
  "account.join_modal.day": "Päev",
  "account.join_modal.me": "Ühinesid {server} serveriga aadressil",
  "account.join_modal.me_anniversary": "Sinu tähtpäev Födiversumis! Ühinesid {server} serveriga aadressil",
  "account.join_modal.me_today": "See on sinu esimene päev {server} serveris!",
  "account.join_modal.other": "{name} liitus {server} severiga",
  "account.join_modal.other_today": "Kasutajale {name} on see esimene päev serveris {server}!",
  "account.join_modal.share.celebrate": "Koosta postitus, mis selle ära märgib",
  "account.join_modal.share.intro": "Koosta sissejuhatav postitus",
  "account.join_modal.share.welcome": "Koosta tervituspostitus",
  "account.join_modal.years": "{number, plural, one {aasta} other {aastat}}",
  "account.joined_short": "Liitus",
  "account.languages": "Muuda tellitud keeli",
  "account.last_active": "Viimati aktiivne",
  "account.link_verified_on": "Selle lingi autorsus on kontrollitud {date}",
  "account.locked_info": "Selle konto privaatsusolek on „lukustatud“. Omanik vaatab üle, kes teda jälgida saab.",
  "account.media": "Meedium",
  "account.mention": "Maini kasutajat @{name}",
  "account.menu.add_to_list": "Lisa loendisse…",
  "account.menu.block": "Blokeeri kasutajakonto",
  "account.menu.block_domain": "Blokeeri {domain}",
  "account.menu.copied": "Kasutajakonto link on kopeeritud lõikelauale",
  "account.menu.copy": "Kopeeri link",
  "account.menu.direct": "Maini privaatselt",
  "account.menu.hide_reblogs": "Peida hooandmised ajajoonelt",
  "account.menu.mention": "Mainimine",
  "account.menu.mute": "Summuta kasutajakonto",
  "account.menu.note.description": "Nähtav ainult sulle",
  "account.menu.open_original_page": "Vaata {domain} saidis",
  "account.menu.remove_follower": "Eemalda jälgija",
  "account.menu.report": "Teata kasutajakontost",
  "account.menu.share": "Jaga…",
  "account.menu.show_reblogs": "Näita ajajoonel hooandmisi",
  "account.menu.unblock": "Lõpeta konto blokeerimine",
  "account.menu.unblock_domain": "Lõpeta {domain} domeeni blokeerimine",
  "account.menu.unmute": "Lõpeta kasutajakonto summutamine",
  "account.moved_to": "{name} on teada andnud, et ta uus konto on nüüd:",
  "account.mute": "Summuta @{name}",
  "account.mute_notifications_short": "Summuta teavitused",
  "account.mute_short": "Summuta",
  "account.muted": "Summutatud",
  "account.mutual": "Te jälgite teineteist",
  "account.name.copy": "Kopeeri kasutajatunnus",
  "account.name.help.domain": "{domain} on server, kus antud konto koos profiiliga asub ning kust postitused saavad alguse.",
  "account.name.help.domain_self": "{domain} on server, kus sinu konto koos profiiliga asub ning kust sinu postitused saavad alguse.",
  "account.name.help.footer": "Nii nagu saad saata e-kirju inimestele, kes kasutavad erinevaid e-posti teenusepakkujaid, saad suhelda ka teiste Mastodoni serverite kasutajatega ning kõigi teistega muudest Födiversumi rakendustest.",
  "account.name.help.header": "Kasutajatunnus on nagu e-posti aadress",
  "account.name.help.username": "{username} on selle konto kasutajanimi tema serveris. Kellelgi teisel mõnes muus serveris võib olla sama kasutajanimi.",
  "account.name.help.username_self": "{username} on sinu kasutajanimi selles serveris. Kellelgi teisel mõnes muus serveris võib olla sama kasutajanimi.",
  "account.name_info": "Mida see tähendab?",
  "account.no_bio": "Kirjeldust pole lisatud.",
  "account.node_modal.callout": "Isiklikud märked on nähtavad vaid sulle.",
  "account.node_modal.edit_title": "Muuda isiklikku märget",
  "account.node_modal.error_unknown": "Märke salvestamine ei õnnestunud",
  "account.node_modal.field_label": "Isiklik märge",
  "account.node_modal.save": "Salvesta",
  "account.node_modal.title": "Lisa isiklik märge",
  "account.note.edit_button": "Muuda",
  "account.note.title": "Isiklikud märked (nähtavad vaid sulle)",
  "account.open_original_page": "Ava algne leht",
  "account.pending": "Ootel",
  "account.posts": "Postitused",
  "account.remove_from_followers": "Eemalda {name} jälgijate seast",
  "account.report": "Teata kasutajast {name}",
  "account.requested_follow": "{name} on soovinud sinu jälgimist",
  "account.share": "Jaga @{name} profiili",
  "account.show_reblogs": "Näita @{name} jagamisi",
  "account.statuses_counter": "{count, plural, one {{counter} postitus} other {{counter} postitust}}",
  "account.timeline.pinned": "Esiletõstetud",
  "account.timeline.pinned.view_all": "Vaata kõiki esiletõstetud postitusi",
  "account.unblock": "Lõpeta {name} kasutaja blokeerimine",
  "account.unblock_domain": "Lõpeta {domain} domeeni blokeerimine",
  "account.unblock_domain_short": "Lõpeta blokeerimine",
  "account.unblock_short": "Lõpeta blokeerimine",
  "account.unendorse": "Ära kuva profiilis",
  "account.unfollow": "Ära jälgi",
  "account.unmute": "Lõpeta {name} kasutaja summutamine",
  "account.unmute_notifications_short": "Lõpeta teavituste summutamine",
  "account.unmute_short": "Lõpeta summutamine",
  "account_edit.advanced_settings.bot_hint": "Teavita teisi, et sel kontol tehakse peamiselt automatiseeritud toiminguid ja seda ei pruugita jälgida",
  "account_edit.advanced_settings.bot_label": "Automatiseeritud kasutajakonto",
  "account_edit.advanced_settings.title": "Täpsemad seadistused",
  "account_edit.bio.add_label": "Lisa elulugu",
  "account_edit.bio.edit_label": "Muuda elulugu",
  "account_edit.bio.placeholder": "Lisa lühike tutvustus, et aidata teistel sinust pilti luua.",
  "account_edit.bio.title": "Elulugu",
  "account_edit.bio_modal.add_title": "Lisa elulugu",
  "account_edit.bio_modal.edit_title": "Muuda elulugu",
  "account_edit.column_button": "Valmis",
  "account_edit.column_title": "Muuda profiili",
  "account_edit.custom_fields.add_label": "Lisa väli",
  "account_edit.custom_fields.edit_label": "Muuda välja",
  "account_edit.custom_fields.placeholder": "Lisa oma asesõnad, välislingid või mistahes muu, mida soovid jagada.",
  "account_edit.custom_fields.reorder_button": "Järjesta välju ümber",
  "account_edit.custom_fields.tip_content": "Saad Mastodoni konto usaldusväärsust hõlpsasti suurendada, verifitseerides lingid veebisaitidele, mis sulle kuuluvad.",
  "account_edit.custom_fields.tip_title": "Soovitus: Kinnitatud linkide lisamine",
  "account_edit.custom_fields.title": "Kohandatud väljad",
  "account_edit.custom_fields.verified_hint": "Kuidas lisada kinnitatud linki?",
  "account_edit.display_name.add_label": "Lisa kuvatav nimi",
  "account_edit.display_name.edit_label": "Muuda kuvatavat nime",
  "account_edit.display_name.placeholder": "Kuvatav nimi määrab, kuidas sinu nimi on näha sinu profiilis ja ajajoontel.",
  "account_edit.display_name.title": "Kuvatav nimi",
  "account_edit.featured_hashtags.edit_label": "Lisa teemaviiteid",
  "account_edit.featured_hashtags.placeholder": "Aita teistel leida su lemmikteemasid ja neile kiiresti juurde pääseda.",
  "account_edit.featured_hashtags.title": "Esiletõstetud teemaviited",
  "account_edit.field_actions.delete": "Kustuta väli",
  "account_edit.field_actions.edit": "Muuda välja",
  "account_edit.field_delete_modal.confirm": "Kas oled kindel, et soovid selle kohandatud välja kustutada? Seda toimingut ei saa tagasi võtta.",
  "account_edit.field_delete_modal.delete_button": "Kustuta",
  "account_edit.field_delete_modal.title": "Kas kustutame kohandatud välja?",
  "account_edit.field_edit_modal.add_title": "Lisa kohandatud väli",
  "account_edit.field_edit_modal.discard_confirm": "Loobu",
  "account_edit.field_edit_modal.discard_message": "Sul on salvestamata muudatusi. Kas soovid tõesti neist loobuda?",
  "account_edit.field_edit_modal.edit_title": "Muuda kohandatud välja",
  "account_edit.field_edit_modal.length_warning": "Soovitatud tähemärkide piir on ületatud. Mobiilikasutajad ei pruugi seda välja tervikuna näha.",
  "account_edit.field_edit_modal.link_emoji_warning": "Soovitame vältida kohandatud emojide kasutamist koos võrguaadressidega. Mõlemat sisaldavad kohandatud väljad kuvatakse segaduse vältimiseks ainult tekstina, mitte lingina.",
  "account_edit.field_edit_modal.name_hint": "Näit. \"Isiklik veebileht\"",
  "account_edit.field_edit_modal.name_label": "Silt",
  "account_edit.field_edit_modal.url_warning": "Lingi lisamisel lisa palun algusesse {protocol}.",
  "account_edit.field_edit_modal.value_hint": "Näit. \"https://naiteks.me\"",
  "account_edit.field_edit_modal.value_label": "Väärtus",
  "account_edit.field_reorder_modal.drag_cancel": "Lohistamine tühistati. „{item}“ väli on eemaldatud.",
  "account_edit.field_reorder_modal.drag_end": "„{item}“ väli eemaldati.",
  "account_edit.field_reorder_modal.drag_instructions": "Kohandatud väljade järjestuse muutmiseks vajuta tühikut või sisestusklahvi. Lohistamise ajal kasuta nooleklahve, et liigutada välja üles või alla. Vajuta uuesti tühikut või sisestusklahvi, et paigutada väli uuele kohale, või tühistamiseks vajuta Esc-klahvi.",
  "account_edit.field_reorder_modal.drag_move": "„{item}“ väli on teisaldatud.",
  "account_edit.field_reorder_modal.drag_over": "„{item}“ väli teisaldati „{over}“ välja kohale.",
  "account_edit.field_reorder_modal.drag_start": "Valisid „{item}“ välja.",
  "account_edit.field_reorder_modal.handle_label": "Lohistad „{item}“ välja",
  "account_edit.field_reorder_modal.title": "Väljade järjestuse muutmine",
  "account_edit.image_alt_modal.add_title": "Lisa selgitustekst",
  "account_edit.image_alt_modal.details_content": "TEE NII: <ul> <li>Kirjelda end pildil olevana</li> <li>Kasuta kolmandat isikut (nt „Alex“ mitte „mina“)</li> <li>Ole lakooniline – paar sõna on sageli piisav</li> </ul> ÄRA TEE NII: <ul> <li>Ära alusta sõnadega „Foto“ – see on ekraanilugeja kasutajale üleliigne</li> </ul> NÄIDE: <ul> <li>„Alex, kes kannab rohelist särki ja prille“</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Soovitus: Selgitustekst profiili fotode jaoks",
  "account_edit.image_alt_modal.edit_title": "Muuda selgitusteksti",
  "account_edit.image_alt_modal.text_hint": "Selgitustekst aitab ekraanilugeja kasutajatel sinu sisu mõista.",
  "account_edit.image_alt_modal.text_label": "Selgitustekst",
  "account_edit.image_delete_modal.confirm": "Kas oled kindel, et soovid selle pildi kustutada? Seda toimingut ei saa tagasi võtta.",
  "account_edit.image_delete_modal.delete_button": "Kustuta",
  "account_edit.image_delete_modal.title": "Kas kustutad pildi?",
  "account_edit.image_edit.add_button": "Lisa pilt",
  "account_edit.image_edit.alt_add_button": "Lisa selgitustekst",
  "account_edit.image_edit.alt_edit_button": "Muuda selgitusteksti",
  "account_edit.image_edit.remove_button": "Eemalda pilt",
  "account_edit.image_edit.replace_button": "Asenda pilt",
  "account_edit.item_list.delete": "Kustuta {name}",
  "account_edit.item_list.edit": "Muuda {name}",
  "account_edit.name_modal.add_title": "Lisa kuvatav nimi",
  "account_edit.name_modal.edit_title": "Muuda kuvatavat nime",
  "account_edit.profile_tab.button_label": "Kohanda",
  "account_edit.profile_tab.hint.description": "Need seadistused määravad, mida kasutajad näevad {server} serveri ametlikes rakendustes, kuid ei pruugi kehtida teiste serverite kasutajate ja kolmandate osapoolte rakenduste puhul.",
  "account_edit.profile_tab.hint.title": "Näitamine siiski võib erineda",
  "account_edit.profile_tab.show_featured.description": "„Esiletõstetud“ on valikuline vahekaart, kus saad näidata teisi kontosid.",
  "account_edit.profile_tab.show_featured.title": "Näita vahekaarti „Esiletõstetud“",
  "account_edit.profile_tab.show_media.description": "„Meedium“ on valikuline vahekaart, mis näitab sinu piltide või videotega postitusi.",
  "account_edit.profile_tab.show_media.title": "Näita multimeedia vahekaarti",
  "account_edit.profile_tab.show_media_replies.description": "Sisselülitatuna näitab mediumi vahekaart, nii sinu postitusi kui su vastuseid teiste kasutajate postitustele.",
  "account_edit.profile_tab.show_media_replies.title": "Kaasa vahekaardile „Meedium“ ka vastused",
  "account_edit.profile_tab.show_relations.description": "Näitab sinu profiilis teistele kasutajatele kontosid, mida jälgid ning su jälgijaid. Inimesed saavad endiselt näha, kas sa neid jälgid.",
  "account_edit.profile_tab.show_relations.title": "Näita „Jälgijad“ ja „Jälgib“",
  "account_edit.profile_tab.subtitle": "Kohanda, kuidas su profiili näidatakse.",
  "account_edit.profile_tab.title": "Profiili näitamise seaded",
  "account_edit.save": "Salvesta",
  "account_edit.upload_modal.back": "Tagasi",
  "account_edit.upload_modal.done": "Valmis",
  "account_edit.upload_modal.next": "Edasi",
  "account_edit.upload_modal.step_crop.zoom": "Suum",
  "account_edit.upload_modal.step_upload.button": "Sirvi faile",
  "account_edit.upload_modal.step_upload.dragging": "Sisu üleslaadimiseks lohista ta siia",
  "account_edit.upload_modal.step_upload.header": "Vali pilt",
  "account_edit.upload_modal.step_upload.hint": "WEBP-, PNG-, GIF- või JPG-vormingus, maksimaalselt {limit} MB.{br}Pilt skaleeritakse mõõtmeteni {width}x{height} pikselit.",
  "account_edit.upload_modal.title_add.avatar": "Lisa profiilipilt",
  "account_edit.upload_modal.title_add.header": "Lisa kaanepilt",
  "account_edit.upload_modal.title_replace.avatar": "Profiilipildi vahetamine",
  "account_edit.upload_modal.title_replace.header": "Kaanepildi vahetamine",
  "account_edit.verified_modal.details": "Paranda oma Mastodoni profiili usaldusväärsust, kinnitades isiklike veebisaitide lingid. See toimib järgmiselt:",
  "account_edit.verified_modal.invisible_link.details": "Lisa link oma saidi päisesse. Oluline on atribuut rel=\"me\", mis takistab identiteedivargust kasutajate loodud sisuga veebisaitides. Lehe päises võid {tag} elemendi asemel kasutada isegi silti link, kuid HTML peab olema kättesaadav ka ilma JavaScripti käivitamiseta.",
  "account_edit.verified_modal.invisible_link.summary": "Kuidas ma muudan lingi nähtamatuks?",
  "account_edit.verified_modal.step1.header": "Kopeeri allpool olev HTML-kood ja aseta oma veebisaidi päisesse",
  "account_edit.verified_modal.step2.details": "Kui oled oma veebisaidi kohandatud väljana juba lisanud, pead kinnitamise käivitamiseks selle kustutama ja uuesti lisama.",
  "account_edit.verified_modal.step2.header": "Lisa oma veebisait kohandatud väljana",
  "account_edit.verified_modal.title": "Kuidas toimib kinnitatud lingi lisamine",
  "account_edit_tags.add_tag": "Lisa #{tagName}",
  "account_edit_tags.column_title": "Muuda silte",
  "account_edit_tags.help_text": "Esiletõstetud teemaviited aitavad kasutajatel sinu profiili leida ja sellega suhestuda. Need kuvatakse filtritena sinu profiili lehe tegevuste vaates.",
  "account_edit_tags.max_tags_reached": "Oled jõudnud esiletõstetud teemaviidete maksimumarvuni.",
  "account_edit_tags.search_placeholder": "Sisesta teemaviide…",
  "account_edit_tags.suggestions": "Soovitused:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# postitus} other {# postitust}}",
  "account_list.hidden_notice": "See on nähtav ainult sulle. Kui soovid seda loetelu teistele näidata, ava <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# konto} other {# kontot}}",
  "account_note.placeholder": "Klõpsa märke lisamiseks",
  "admin.dashboard.daily_retention": "Kasutajate päevane allesjäämine peale registreerumist",
  "admin.dashboard.monthly_retention": "Kasutajate kuine allesjäämine peale registreerumist",
  "admin.dashboard.retention.average": "Keskmine",
  "admin.dashboard.retention.cohort": "Liitumiskuu",
  "admin.dashboard.retention.cohort_size": "Uued kasutajad",
  "admin.impact_report.instance_accounts": "Kontode profiilid, mille see kustutaks",
  "admin.impact_report.instance_followers": "Jälgijad, kelle meie kasutajad kaotaks",
  "admin.impact_report.instance_follows": "Jälgijad, mille nende kasutajad kaotaks",
  "admin.impact_report.title": "Mõju kokkuvõte",
  "alert.rate_limited.message": "Palun proovi uuesti pärast {retry_time, time, medium}.",
  "alert.rate_limited.title": "Kiiruspiirang",
  "alert.unexpected.message": "Tekkis ootamatu viga.",
  "alert.unexpected.title": "Vaat kus lops!",
  "alt_text_badge.title": "Selgitustekst",
  "alt_text_modal.add_alt_text": "Lisa selgitustekst",
  "alt_text_modal.add_text_from_image": "Lisa tekst pildilt",
  "alt_text_modal.cancel": "Katkesta",
  "alt_text_modal.change_thumbnail": "Muuda pisipilti",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Kirjelda seda kuulmispuudega inimeste jaoks…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Kirjelda seda nägemispuudega inimeste jaoks…",
  "alt_text_modal.done": "Valmis",
  "announcement.announcement": "Teadaanne",
  "annual_report.announcement.action_build": "Koosta kokkuvõte minu tegevusest Mastodonis",
  "annual_report.announcement.action_dismiss": "Tänan, ei",
  "annual_report.announcement.action_view": "Vaata kokkuvõtet minu tegevusest Mastodonis",
  "annual_report.announcement.description": "Vaata teavet oma suhestumise kohta Mastodonis eelmisel aastal.",
  "annual_report.announcement.title": "{year}. aasta Mastodoni kokkuvõte on valmis",
  "annual_report.nav_item.badge": "Uus",
  "annual_report.shared_page.donate": "Toeta rahaliselt",
  "annual_report.shared_page.footer": "Loodud suure {heart}-ga Mastodoni meeskonna poolt",
  "annual_report.shared_page.footer_server_info": "{username} kasutab {domain}-i, üht paljudest kogukondadest, mis toimivad Mastodonil.",
  "annual_report.summary.archetype.booster.desc_public": "{name} jätkas postituste otsimist, et neid edendada, tugevdades teisi loojaid täiusliku täpsusega.",
  "annual_report.summary.archetype.booster.desc_self": "Sa jätkasid postituste otsimist, et neid edendada, tugevdades teisi loojaid täiusliku täpsusega.",
  "annual_report.summary.archetype.booster.name": "Vibukütt",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Me teame, et {name} oli kusagil seal väljas ja nautis Mastodoni oma vaiksel moel.",
  "annual_report.summary.archetype.lurker.desc_self": "Me teame, et sa olid kusagil seal väljas ja nautisid Mastodoni oma vaiksel moel.",
  "annual_report.summary.archetype.lurker.name": "Stoiline",
  "annual_report.summary.archetype.oracle.desc_public": "{name} lõi rohkem uusi postitusi kui vastuseid, hoides Mastodoni värskena ja tulevikku suunatuna.",
  "annual_report.summary.archetype.oracle.desc_self": "Sa lõid rohkem uusi postitusi kui vastuseid, hoides Mastodoni värskena ja tulevikku suunatuna.",
  "annual_report.summary.archetype.oracle.name": "Oraakel",
  "annual_report.summary.archetype.pollster.desc_public": "{name} koostas rohkem küsitlusi kui teisi postituse tüüpe, äratades Mastodonis uudishimu.",
  "annual_report.summary.archetype.pollster.desc_self": "Sa koostasid rohkem küsitlusi kui teisi postituse tüüpe, äratades Mastodonis uudishimu.",
  "annual_report.summary.archetype.pollster.name": "Uudishimulik",
  "annual_report.summary.archetype.replier.desc_public": "{name} vastas sageli teiste inimeste postitustele, pakkudes Mastodonile uusi aruteluteemasid.",
  "annual_report.summary.archetype.replier.desc_self": "Sa vastasid sageli teiste inimeste postitustele, pakkudes Mastodonile uusi aruteluteemasid.",
  "annual_report.summary.archetype.replier.name": "Liblikas",
  "annual_report.summary.archetype.reveal": "Näita mu põhitüüpi",
  "annual_report.summary.archetype.reveal_description": "Täname, et oled tegutsed Mastodoni võrgus! Aeg on välja selgitada, millist põhitüüpi sa {year}. aastal kehastasid.",
  "annual_report.summary.archetype.title_public": "Kasutaja {name} põhitüüp",
  "annual_report.summary.archetype.title_self": "Sinu põhitüüp",
  "annual_report.summary.close": "Sulge",
  "annual_report.summary.copy_link": "Kopeeri link",
  "annual_report.summary.followers.new_followers": "{count, plural, one {uus jälgija} other {uut jälgijat}}",
  "annual_report.summary.highlighted_post.boost_count": "Seda postitust on jagatud {count, plural, one {ühe korra} other {# korda}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Seda postitust on lemmikuks märgitud {count, plural, one {ühe korra} other {# korda}}.",
  "annual_report.summary.highlighted_post.reply_count": "See postitus on saanud {count, plural, one {ühe vastuse} other {# vastust}}.",
  "annual_report.summary.highlighted_post.title": "Kõige populaarsemad postitused",
  "annual_report.summary.most_used_app.most_used_app": "enimkasutatud rakendus",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "enim kasutatud teemaviide",
  "annual_report.summary.most_used_hashtag.used_count": "Sa lisasid selle teemaviite {count, plural, one {ühele postitusele} other {#-le postitusele}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} kasutas seda teemaviidet {count, plural, one {ühes postituses} other {#-s postituses}}.",
  "annual_report.summary.new_posts.new_posts": "uued postitused",
  "annual_report.summary.percentile.text": "<topLabel>See paneb su top</topLabel><percentage></percentage><bottomLabel> {domain} serveri kasutajate hulka.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Vägev.",
  "annual_report.summary.share_elsewhere": "Jaga mujal",
  "annual_report.summary.share_message": "Minu arhetüüp on {archetype}!",
  "annual_report.summary.share_on_mastodon": "Jaga Mastodonis",
  "attachments_list.unprocessed": "(töötlemata)",
  "audio.hide": "Peida heliriba",
  "block_modal.no_collections": "Kumbki teist ei saa teineteist kogumikesse lisada. Vajaduse korral eemaldatakse teid automaatselt teineteise olemasolevatest kogumikest.",
  "block_modal.remote_users_caveat": "Serverile {domain} edastatakse palve otsust järgida. Ometi pole see tagatud, kuna mõned serverid võivad blokeeringuid käsitleda omal moel. Avalikud postitused võivad tuvastamata kasutajatele endiselt näha olla.",
  "block_modal.show_less": "Kuva vähem",
  "block_modal.show_more": "Kuva rohkem",
  "block_modal.they_cant_mention": "Te ei saa üksteist mainida, jälgida ega tsiteerida.",
  "block_modal.they_cant_see_posts": "Nad ei näe sinu sisu ja sina ei näe nende oma.",
  "block_modal.they_will_know": "Ta näeb, et ta on blokeeritud.",
  "block_modal.title": "Kas blokeerid kasutaja?",
  "block_modal.you_wont_see_mentions": "Sa ei näe teiste postitusi, milles neid mainitakse.",
  "boost_modal.combo": "Vajutades {combo}, saad selle edaspidi vahele jätta",
  "boost_modal.reblog": "Jagada postitust?",
  "boost_modal.undo_reblog": "Tühista postituse jagamine?",
  "bundle_column_error.copy_stacktrace": "Kopeeri veateade",
  "bundle_column_error.error.body": "Soovitud lehte ei õnnestunud esitada. See võib olla meie koodiviga või probleem brauseri ühilduvusega.",
  "bundle_column_error.error.title": "Oh, ei!",
  "bundle_column_error.network.body": "Lehe laadimisel tekkis tõrge. See võib olla ajutine probleem internetiühendusega või selle serveriga.",
  "bundle_column_error.network.title": "Võrguühenduse viga",
  "bundle_column_error.retry": "Proovi uuesti",
  "bundle_column_error.return": "Tagasi koju",
  "bundle_column_error.routing.body": "Päritud lehte ei leitud. Kas URL on aadressiribal õige?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Sulge",
  "bundle_modal_error.message": "Selle ekraanitäie laadimisel läks midagi valesti.",
  "bundle_modal_error.retry": "Proovi uuesti",
  "callout.dismiss": "Loobu",
  "carousel.current": "<sr>Slaid</sr> {current, number} / {max, number}",
  "carousel.slide": "Slaid {current, number} / {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} soovitatud märke",
  "character_counter.required": "{currentLength}/{maxLength} märki",
  "closed_registrations.other_server_instructions": "Kuna Mastodon on detsentraliseeritud, võib konto teha teise serverisse ja sellegipoolest siinse kontoga suhelda.",
  "closed_registrations_modal.description": "Praegu ei ole võimalik teha {domain} peale kontot, aga pea meeles, et sul ei pea olema just {domain} konto, et Mastodoni kasutada.",
  "closed_registrations_modal.find_another_server": "Leia mõni muu server",
  "closed_registrations_modal.preamble": "Mastodon on hajutatud võrk, mis tähendab, et konto võid luua ükskõik kuhu, kuid ikkagi saad jälgida ja suhelda igaühega selles serveris. Võid isegi oma serveri püsti panna!",
  "closed_registrations_modal.title": "Mastodoni registreerumine",
  "collection.share_modal.share_link_label": "Jaga linki",
  "collection.share_modal.share_via_post": "Postita Mastodonis",
  "collection.share_modal.share_via_system": "Jaga kohas…",
  "collection.share_modal.title": "Jaga kogumikku",
  "collection.share_modal.title_new": "Jaga oma ut kogumikku!",
  "collection.share_template_other": "Vaata seda lahedat kogumikku: {link}",
  "collection.share_template_own": "Vaata mu uut kogumikku: {link}",
  "collections.account_count": "{count, plural, one {# kasutajakonto} other {# kasutajakontot}}",
  "collections.accounts.empty_description": "Lisa kuni {count} kontot",
  "collections.accounts.empty_editor_title": "Selles kogumikus pole veel kedagi",
  "collections.accounts.empty_title": "See kogumik on tühi",
  "collections.block_collection_owner": "Konto blokeerimine",
  "collections.by_account": "{account_handle} poolt",
  "collections.collection_description": "Kirjeldus",
  "collections.collection_language": "Keel",
  "collections.collection_language_none": "Pole",
  "collections.collection_name": "Nimi",
  "collections.collection_topic": "Teema",
  "collections.confirm_account_removal": "Kas oled kindel, et soovid selle konto kogumikust eemaldada?",
  "collections.content_warning": "Sisuhoiatus",
  "collections.continue": "Jätka",
  "collections.copy_link": "Kopeeri link",
  "collections.copy_link_confirmation": "Kogumiku link kopeeriti lõikelauale",
  "collections.create.accounts_title": "Kes saavad olema selles kogumikus?",
  "collections.create.basic_details_title": "Põhiandmed",
  "collections.create.steps": "Samm {step}/{total}",
  "collections.create_collection": "Loo kogumik",
  "collections.delete_collection": "Kustuta kogumik",
  "collections.description_length_hint": "Kuni 100 tähemärki",
  "collections.detail.author_added_you_on_date": "{author} lisas sind ajal {date}",
  "collections.detail.loading": "Kogumiku laadimine…",
  "collections.detail.revoke_inclusion": "Eemalda mind",
  "collections.detail.sensitive_content": "Tundlik sisu",
  "collections.detail.sensitive_note": "Selles kogumikus on kontosid ja sisu, mis võib mõne inimese jaoks olla tundlik.",
  "collections.detail.share": "Jaga seda kogumikku",
  "collections.detail.you_are_in_this_collection": "Sa oled selles kogumikus esile tõstetud",
  "collections.edit_details": "Muuda üksikasju",
  "collections.error_loading_collections": "Nende kogumike laadimisel juhtus viga.",
  "collections.hidden_accounts_description": "Oled blokeerinud või vaigistanud {count, plural, one {selle kasutaja} other {need kasutajad}}",
  "collections.hidden_accounts_link": "{count, plural, one {# peidetud konto} other {# peidetud kontot}}",
  "collections.hints.accounts_counter": "{count}/{max} kontot",
  "collections.last_updated_at": "Viimati uuendatud: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# kogumik} other {# kogumikku}}",
  "collections.list.created_by_author": "Looja: {name}",
  "collections.list.created_by_you": "Sinu poolt loodud",
  "collections.list.featuring_you": "Tõstab sind esile",
  "collections.manage_accounts": "Halda kasutajakontosid",
  "collections.mark_as_sensitive": "Märgi delikaatseks",
  "collections.mark_as_sensitive_hint": "Peidab kogumiku kirjelduse ja kontod sisuhoiatuse taha. Kogumiku nimi ise on sellele vaatamata nähtav.",
  "collections.maximum_collection_count_description": "Sinu server lubab luua kuni {count} kogumikku.",
  "collections.maximum_collection_count_reached": "Sa oled loonud nii palju kogumikke, kui on lubatud",
  "collections.name_length_hint": "40 märgi piir",
  "collections.new_collection": "Uus kogumik",
  "collections.pending_accounts.message": "Kui oled ootamst vastut kasutajalt oma serverist, võivad kasutajakontod tunduda olema ootel olekus. Vaid sina saad näha ootel kasutajakontosid.",
  "collections.pending_accounts.title": "Miks ma näen ootel kasutajakontosid?",
  "collections.remove_account": "Eemalda",
  "collections.report_collection": "Raporteeri sellest kogumikust",
  "collections.revoke_collection_inclusion": "Eemalda mind sellest kogumikust",
  "collections.revoke_inclusion.confirmation": "Oled eemaldatud \"{collection}\"-st",
  "collections.revoke_inclusion.error": "Oli viga, palun proovi hiljem uuesti.",
  "collections.search_accounts_label": "Otsi kontot, mida lisada",
  "collections.search_accounts_max_reached": "Oled lisanud maksimumarv kontosid",
  "collections.sensitive": "Tundlik",
  "collections.share_short": "Jaga",
  "collections.suggestions.can_not_add": "Ei saa lisada",
  "collections.suggestions.can_not_add_desc": "Need kontod võivad olla loobunud avalikustamisest või asuvad serveris, mis ei toeta kogumikke.",
  "collections.suggestions.must_follow": "Kõigepealt peab jälgima",
  "collections.suggestions.must_follow_desc": "Need kontod vaatavad kõik jälgimispalved läbi. Jälgijad saavad neid kogumikesse lisada.",
  "collections.topic_hint": "Lisa teemaviide, mis aitab teistel kasutajatel mõista selle kogumiku põhisisu.",
  "collections.topic_special_chars_hint": "Erimärgid eemaldatakse salvestamisel",
  "collections.unlisted_collections_description": "Need pole sinu profiilis teiste kasutajate jaoks nähtavad. Neid saavad vaadata kõik, kellel on link.",
  "collections.unlisted_collections_with_count": "Loetlemata kogumikud ({count})",
  "collections.view_collection": "Vaata kogumikku",
  "collections.visibility_public": "Avalik",
  "collections.visibility_public_hint": "Leitav otsingutulemustes ja muudes kohtades, kus on näha soovitusi.",
  "collections.visibility_title": "Nähtavus",
  "collections.visibility_unlisted": "Ajajooneväline",
  "collections.visibility_unlisted_hint": "Nähtav kõigile, kes teavad linki. Peidetud otsingutulemustest ja soovitustest.",
  "column.about": "Teave",
  "column.blocks": "Blokeeritud kasutajad",
  "column.bookmarks": "Järjehoidjad",
  "column.community": "Kohalik ajajoon",
  "column.create_list": "Loo loend",
  "column.direct": "Privaatsed mainimised",
  "column.directory": "Sirvi profiile",
  "column.domain_blocks": "Blokeeritud domeenid",
  "column.edit_list": "Muuda loendit",
  "column.favourites": "Lemmikud",
  "column.firehose": "Postitused reaalajas",
  "column.firehose_local": "Selle serveri sisuvoog reaalajas",
  "column.firehose_singular": "Postitused reaalajas",
  "column.follow_requests": "Jälgimistaotlused",
  "column.home": "Kodu",
  "column.list_members": "Halda loendi liikmeid",
  "column.lists": "Loetelud",
  "column.mutes": "Summutatud kasutajad",
  "column.notifications": "Teated",
  "column.other_collections": "Kasutaja {name} kogumikud",
  "column.pins": "Esiletõstetud postitused",
  "column.public": "Föderatiivne ajajoon",
  "column.your_collections": "Sinu kogumikud",
  "column_back_button.label": "Tagasi",
  "column_header.hide_settings": "Peida sätted",
  "column_header.moveLeft_settings": "Liiguta tulp vasakule",
  "column_header.moveRight_settings": "Liiguta tulp paremale",
  "column_header.pin": "Kinnita",
  "column_header.show_settings": "Näita sätteid",
  "column_header.unpin": "Eemalda kinnitus",
  "column_search.cancel": "Tühista",
  "combobox.close_results": "Sulge tulemused",
  "combobox.loading": "Laadimisel",
  "combobox.no_results_found": "Sellel otsingul pole tulemusi",
  "combobox.open_results": "Vaata tulemusi",
  "combobox.results_available": "Saadaval on {count, plural, one {# soovitus} other {# soovitust}}. Liikumiseks kasuta üles/alla nooli. Valimiseks vajuta sisestusklahvi.",
  "community.column_settings.local_only": "Ainult kohalik",
  "community.column_settings.media_only": "Ainult meedia",
  "community.column_settings.remote_only": "Ainult kaug",
  "compose.error.blank_post": "Postitus ei saa jääda tühjaks.",
  "compose.language.change": "Muuda keelt",
  "compose.language.search": "Otsi keeli...",
  "compose.published.body": "Postitus tehtud.",
  "compose.published.open": "Ava",
  "compose.saved.body": "Postitus salvestatud.",
  "compose_form.direct_message_warning_learn_more": "Vaata lisa",
  "compose_form.encryption_warning": "Postitused Mastodonis ei ole otsast-otsani krüpteeritud. Ära jaga mingeid delikaatseid andmeid Mastodoni kaudu.",
  "compose_form.hashtag_warning": "See postitus ei ilmu ühegi teemaviite all, kuna pole avalik. Vaid avalikud postitused on teemaviidete kaudu leitavad.",
  "compose_form.lock_disclaimer": "Su konto ei ole {locked}. Igaüks saab sind jälgida, et näha su ainult-jälgijatele postitusi.",
  "compose_form.lock_disclaimer.lock": "lukus",
  "compose_form.placeholder": "Millest mõtled?",
  "compose_form.poll.duration": "Küsitluse kestus",
  "compose_form.poll.multiple": "Mitu vastust",
  "compose_form.poll.option_placeholder": "Valik {number}",
  "compose_form.poll.single": "Üks valik",
  "compose_form.poll.switch_to_multiple": "Muuda küsitlust mitmikvaliku lubamiseks",
  "compose_form.poll.switch_to_single": "Muuda küsitlust ainult ühe valiku lubamiseks",
  "compose_form.poll.type": "Stiil",
  "compose_form.publish": "Postita",
  "compose_form.reply": "Vasta",
  "compose_form.save_changes": "Uuenda",
  "compose_form.spoiler.marked": "Tekst on hoiatuse taha peidetud",
  "compose_form.spoiler.unmarked": "Märgi sisu tundlikuks",
  "compose_form.spoiler_placeholder": "Sisuhoiatus (valikuline)",
  "confirmation_modal.cancel": "Katkesta",
  "confirmations.block.confirm": "Blokeeri",
  "confirmations.delete.confirm": "Kustuta",
  "confirmations.delete.message": "Oled kindel, et soovid postituse kustutada?",
  "confirmations.delete.title": "Kustutada postitus?",
  "confirmations.delete_collection.confirm": "Kustuta",
  "confirmations.delete_collection.message": "Seda tegevust ei saa tagasi pöörata.",
  "confirmations.delete_collection.title": "Kas kustutad: {name}?",
  "confirmations.delete_list.confirm": "Kustuta",
  "confirmations.delete_list.message": "Oled kindel, et soovid selle loetelu pöördumatult kustutada?",
  "confirmations.delete_list.title": "Kustutada loetelu?",
  "confirmations.discard_draft.confirm": "Loobu ja jätka",
  "confirmations.discard_draft.edit.cancel": "Jätka muutmist",
  "confirmations.discard_draft.edit.message": "Jätkates loobud kõikidest sellese postitusse tehtud muudatustest.",
  "confirmations.discard_draft.edit.title": "Kas loobud oma postituse muudatustest?",
  "confirmations.discard_draft.post.cancel": "Jätka kavandi koostamist",
  "confirmations.discard_draft.post.message": "Jätkates loobud hetkel koostamisel postituse kõikidest muudatustest.",
  "confirmations.discard_draft.post.title": "Kas loobud postituse kavandist?",
  "confirmations.discard_edit_media.confirm": "Hülga",
  "confirmations.discard_edit_media.message": "Sul on salvestamata muudatusi meediakirjelduses või eelvaates, kas hülgad need?",
  "confirmations.follow_to_list.confirm": "Jälgi ja lisa loetellu",
  "confirmations.follow_to_list.message": "Pead jälgima kasutajat {name}, et lisada teda loetellu.",
  "confirmations.follow_to_list.title": "Jälgida kasutajat?",
  "confirmations.hide_featured_tab.confirm": "Peida vahekaart",
  "confirmations.hide_featured_tab.intro": "Saad seda igal ajal muuta menüüs <i>Profiili muutmine > Profiili vahekaardi seaded</i>.",
  "confirmations.hide_featured_tab.message": "See peidab vahekaardi serveri {serverName} kasutajatel ja teistel serveritel, kus kasutatakse Mastodoni uusimat versiooni. Muudel serveritel võib kuvamine erineda.",
  "confirmations.hide_featured_tab.title": "Kas peidame vahekaardi „Esiletõstetud“?",
  "confirmations.logout.confirm": "Välju",
  "confirmations.logout.message": "Kas oled kindel, et soovid välja logida?",
  "confirmations.logout.title": "Logida välja?",
  "confirmations.missing_alt_text.confirm": "Lisa alt-tekst",
  "confirmations.missing_alt_text.message": "Sinu postituses on ilma alt-tekstita meediat. Kirjelduse lisamine aitab su sisu muuta ligipääsetavaks rohkematele inimestele.",
  "confirmations.missing_alt_text.secondary": "Postita siiski",
  "confirmations.missing_alt_text.title": "Lisada alt-tekst?",
  "confirmations.mute.confirm": "Summuta",
  "confirmations.private_quote_notify.cancel": "Tagasi muutmise juurde",
  "confirmations.private_quote_notify.confirm": "Avalda postitus",
  "confirmations.private_quote_notify.do_not_show_again": "Ära kuva enam seda sõnumit uuesti",
  "confirmations.private_quote_notify.message": "Nii see, keda sa tsiteerid, kui need, keda mainid, saavad asjakohase teavituse ja võivad vaadata sinu postitust ka siis, kui nad pole sinu jälgijad.",
  "confirmations.private_quote_notify.title": "Kas jagad jälgijate ja mainitud kasutajatega?",
  "confirmations.quiet_post_quote_info.dismiss": "Ära tuleta enam meelde",
  "confirmations.quiet_post_quote_info.got_it": "Sain aru",
  "confirmations.quiet_post_quote_info.message": "Vaikse, aga avaliku postituse tsiteerimisel sinu postitus on peidetud populaarsust koguvatel ajajoontel.",
  "confirmations.quiet_post_quote_info.title": "Vaikse, aga avaliku postituse tsiteerimine",
  "confirmations.redraft.confirm": "Kustuta & taasalusta",
  "confirmations.redraft.message": "Kindel, et soovid postituse kustutada ja võtta uue aluseks? Lemmikuks märkimised ja jagamised lähevad kaotsi ning vastused jäävad ilma algse postituseta.",
  "confirmations.redraft.title": "Kustudada ja luua postituse mustand?",
  "confirmations.remove_from_followers.confirm": "Eemalda jälgija",
  "confirmations.remove_from_followers.message": "{name} lõpetab sellega sinu jälgimise. Kas oled kindel, et soovid jätkata?",
  "confirmations.remove_from_followers.title": "Kas eemaldame jälgija?",
  "confirmations.revoke_collection_inclusion.confirm": "Eemalda mind",
  "confirmations.revoke_collection_inclusion.message": "See toiming on lõplik ja kuraator ei saa sind hiljem kogumikku uuesti lisada.",
  "confirmations.revoke_collection_inclusion.title": "Kas eemaldad ennast sellest kogumikust?",
  "confirmations.revoke_quote.confirm": "Eemalda postitus",
  "confirmations.revoke_quote.message": "Seda tegevust ei saa tagasi pöörata.",
  "confirmations.revoke_quote.title": "Kas eemaldame postituse?",
  "confirmations.unblock.confirm": "Lõpeta blokeerimine",
  "confirmations.unblock.title": "Kas lõpetad {name} kasutaja blokeerimise?",
  "confirmations.unfollow.confirm": "Ära jälgi",
  "confirmations.unfollow.title": "Kas lõpetad {name} kasutaja jälgimise?",
  "confirmations.withdraw_request.confirm": "Tühista päring",
  "confirmations.withdraw_request.title": "Tühistad päringu {name} kasutaja jälgimiseks?",
  "content_warning.hide": "Peida postitus",
  "content_warning.show": "Näita ikkagi",
  "content_warning.show_more": "Näita rohkem",
  "content_warning.show_short": "Näita",
  "conversation.delete": "Kustuta vestlus",
  "conversation.mark_as_read": "Märgi loetuks",
  "conversation.open": "Vaata vestlust",
  "conversation.with": "Koos {names}",
  "copy_icon_button.copied": "Kopeeritud vahemällu",
  "copy_icon_button.copy_this_text": "Kopeeri link lõikelauale",
  "copypaste.copied": "Kopeeritud",
  "copypaste.copy_to_clipboard": "Kopeeri vahemällu",
  "directory.federated": "Tuntud födiversumist",
  "directory.local": "Ainult domeenilt {domain}",
  "directory.new_arrivals": "Uustulijad",
  "directory.recently_active": "Hiljuti aktiivne",
  "disabled_account_banner.account_settings": "Kontosätted",
  "disabled_account_banner.text": "Su konto {disabledAccount} on hetkel keelatud.",
  "dismissable_banner.community_timeline": "Need on kõige viimased avalikud postitused inimestelt, kelle kontosid majutab {domain}.",
  "dismissable_banner.dismiss": "Sulge",
  "dismissable_banner.public_timeline": "Need on värskeimad avalikud postitused inimestelt fediversiumis, mida domeeni {domain} inimesed jälgivad.",
  "domain_block_modal.block": "Blokeeri server",
  "domain_block_modal.block_account_instead": "Selle asemel blokeeri @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Inimesed sellest serverist saavad suhestuda sinu vanade postitustega.",
  "domain_block_modal.they_cant_follow": "Sellest serverist ei saa keegi sind jälgida.",
  "domain_block_modal.they_wont_know": "Nad ei tea, et nad on blokeeritud.",
  "domain_block_modal.title": "Kas blokeerid domeeni?",
  "domain_block_modal.you_will_lose_num_followers": "Sult kaob {followersCount, plural, one {{followersCountDisplay} jälgija} other {{followersCountDisplay} jälgijat}} ja {followingCount, plural, one {{followingCountDisplay} inimene} other {{followingCountDisplay} inimest}}, keda sa ise jälgid.",
  "domain_block_modal.you_will_lose_relationships": "Sa kaotad kõik oma jälgijad ja inimesed, kes sind jälgivad sellest serverist.",
  "domain_block_modal.you_wont_see_posts": "Sa ei näe selle serveri kasutajate postitusi ega teavitusi.",
  "domain_pill.activitypub_lets_connect": "See võimaldab sul ühenduda inimestega ja nendega suhelda mitte ainult Mastodonis, vaid ka teistes suhtlusrakendustes.",
  "domain_pill.activitypub_like_language": "ActivityPub on nagu keel, mida Mastodon räägib teiste suhtlusvõrgustikega.",
  "domain_pill.server": "Server",
  "domain_pill.their_handle": "Tema tunnus:",
  "domain_pill.their_server": "Tema digitaalne kodu, kus kõik tema postitused on.",
  "domain_pill.their_username": "Tema unikaalne tunnus tema serveris. On võimalik, et mingites teistes serverites on sama kasutajanimega kasutajaid.",
  "domain_pill.username": "Kasutajanimi",
  "domain_pill.whats_in_a_handle": "Mis on tunnuses?",
  "domain_pill.who_they_are": "Kuna tunnus ütleb, kes keegi on ja kus, saad suhelda inimestega üle <button>ActivityPub-poolt toetatud sotsiaalvõrkude platvormide</button>.",
  "domain_pill.who_you_are": "Kuna tunnus ütleb, kes sa oled ja kus, saavad inimesed sinuga suhelda üle <button>ActivityPub-poolt toetatud sotsiaalvõrkude platvormide</button>.",
  "domain_pill.your_handle": "Sinu tunnus:",
  "domain_pill.your_server": "Sinu digitaalne kodu, kus on kõik sinu postitused. Sulle ei meeldi see? Vaheta mistahes ajal serverit ja võta jälgijad ka.",
  "domain_pill.your_username": "Sinu unikaalne identifikaator siin serveris. On võimalik, et leiad teistes serverites samasuguse kasutajanimega kasutajaid.",
  "dropdown.empty": "Vali üks variantidest",
  "email_subscriptions.email": "E-post",
  "email_subscriptions.form.action": "Telli",
  "email_subscriptions.form.bottom": "Saad postitusi postkasti ilma Mastodoni kontot loomata. Tellimuse saab igal ajal tühistada. Lisateave <a>privaatsuspoliitikast</a>.",
  "email_subscriptions.form.title": "Telli {name} e-postiuuendused",
  "email_subscriptions.submitted.lead": "Vaata oma postkasti, kas oled saanud kirja, et lõpetada uudiskirja tellimine.",
  "email_subscriptions.submitted.title": "Veel üks samm",
  "email_subscriptions.validation.email.blocked": "Blokeeritud e-posti teenusepakkuja",
  "email_subscriptions.validation.email.invalid": "Sobimatu e-postiaadress",
  "embed.instructions": "Lisa see postitus oma veebilehele, kopeerides alloleva koodi.",
  "embed.preview": "Nii näeb see välja:",
  "emoji_button.activity": "Tegevus",
  "emoji_button.clear": "Tühjenda",
  "emoji_button.custom": "Mugandatud",
  "emoji_button.flags": "Lipud",
  "emoji_button.food": "Toit & jook",
  "emoji_button.label": "Lisa emoji",
  "emoji_button.nature": "Loodus",
  "emoji_button.not_found": "Ei ole sobivaid emoji'sid! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Objektid",
  "emoji_button.people": "Inimesed",
  "emoji_button.recent": "Tihti kasutatud",
  "emoji_button.search": "Otsi...",
  "emoji_button.search_results": "Otsitulemused",
  "emoji_button.symbols": "Sümbolid",
  "emoji_button.travel": "Reisimine & kohad",
  "empty_column.account_featured.other": "{acct} pole veel midagi esile tõstnud.",
  "empty_column.account_featured_self.no_collections_button": "Loo kogumik",
  "empty_column.account_featured_self.no_collections_hide_tab": "Selle asemel peida see vahekaart",
  "empty_column.account_featured_self.pre_collections": "Jälgi kogumikke",
  "empty_column.account_featured_self.pre_collections_desc": "Kogumikud (lisanduvad Mastodon V4.6) võimaldavad sul luua enda koostatud kontode nimekirju, mida teistele soovitada.",
  "empty_column.account_featured_self.showcase_accounts": "Näita oma lemmikkontosid",
  "empty_column.account_featured_self.showcase_accounts_desc": "Kogumikud on hoolikalt koostatud kontode nimekirjad, mis aitavad teistel Fediverse'i paremini avastada.",
  "empty_column.account_featured_unknown.other": "See konto pole veel midagi esile tõstnud.",
  "empty_column.account_hides_collections": "See kasutaja otsustas mitte teha seda infot kättesaadavaks",
  "empty_column.account_suspended": "Konto kustutatud",
  "empty_column.account_timeline": "Siin postitusi ei ole!",
  "empty_column.account_unavailable": "Profiil pole saadaval",
  "empty_column.blocks": "Blokeeritud kasutajaid pole.",
  "empty_column.bookmarked_statuses": "Järjehoidjatesse pole veel lisatud postitusi. Kui lisad mõne, näed neid siin.",
  "empty_column.collections.featured_in": "Sind pole lisatud veel ühtegi kogumikku.",
  "empty_column.community": "Kohalik ajajoon on tühi. Kirjuta midagi avalikult, et pall veerema ajada!",
  "empty_column.direct": "Sul pole veel ühtegi privaatset mainimist. Kui saadad või saad mõne, ilmuvad need siin.",
  "empty_column.disabled_feed": "See infovoog on serveri peakasutajate poolt välja lülitatud.",
  "empty_column.domain_blocks": "Siin ei ole veel peidetud domeene.",
  "empty_column.explore_statuses": "Praegu pole ühtegi trendi. Tule hiljem tagasi!",
  "empty_column.favourited_statuses": "Pole veel lemmikpostitusi. Kui märgid mõne, näed neid siin.",
  "empty_column.favourites": "Keegi pole veel seda postitust lemmikuks märkinud. Kui keegi seda teeb, siis on ta nähtav siin.",
  "empty_column.follow_requests": "Pole hetkel ühtegi jälgimistaotlust. Kui saad mõne, näed neid siin.",
  "empty_column.followed_tags": "Sa ei jälgi veel ühtegi teemaviidet. Kui jälgid, ilmuvad need siia.",
  "empty_column.hashtag": "Selle teemaviite all ei ole ühtegi postitust.",
  "empty_column.home": "Su koduajajoon on tühi. Jälgi rohkemaid inimesi, et seda täita {suggestions}",
  "empty_column.list": "Siin loetelus pole veel midagi. Kui loetelu liikmed teevad uusi postitusi, näed neid siin.",
  "empty_column.mutes": "Sa pole veel ühtegi kasutajat summutanud.",
  "empty_column.notification_requests": "Kõik tühi! Siin pole mitte midagi. Kui saad uusi teavitusi, ilmuvad need siin vastavalt sinu seadistustele.",
  "empty_column.notifications": "Ei ole veel teateid. Kui keegi suhtleb sinuga, näed seda siin.",
  "empty_column.public": "Siin pole midagi! Kirjuta midagi avalikku või jälgi ise kasutajaid täitmaks seda ruumi",
  "empty_state.no_results": "Tulemusi pole",
  "error.no_hashtag_feed_access": "Selle teemaviite jälgimiseks liitu teenusega või logi sisse oma kasutajakontoga.",
  "error.unexpected_crash.explanation": "Meie poolse probleemi või veebilehitseja ühilduvusprobleemi tõttu ei suutnud me seda lehekülge korrektselt näidata.",
  "error.unexpected_crash.explanation_addons": "Seda lehte ei suudetud õigesti kuvada. Selle vea põhjustas arvatavasti mõni lehitseja lisand või automaattõlke tööriist.",
  "error.unexpected_crash.next_steps": "Proovi lehekülge uuesti avada. Kui see ei aita, võib proovida kasutada Mastodoni mõne muu veebilehitseja või äpi kaudu.",
  "error.unexpected_crash.next_steps_addons": "Proovi need välja lülitada ja leht uuesti laadida. Kui sellest pole abi, võib siiski võimalik olla Mastodoni kasutada mõne teise lehitseja või rakendusega.",
  "errors.unexpected_crash.copy_stacktrace": "Kopeeri stacktrace lõikelauale",
  "errors.unexpected_crash.report_issue": "Teavita veast",
  "explore.suggested_follows": "Inimesed",
  "explore.title": "Populaarsust koguv",
  "explore.trending_links": "Uudised",
  "explore.trending_statuses": "Postitused",
  "explore.trending_tags": "Teemaviited",
  "featured_carousel.current": "<sr>Postitus</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Esiletõstetud postitus} other {Esiletõstetud postitust}}",
  "featured_carousel.slide": "Postitus {current, number} / {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Postitasid hiljuti {items} kohta. Kas lisada need esiletõstetud teemaviideteks?",
  "featured_tags.suggestions.add": "Lisa",
  "featured_tags.suggestions.added": "Halda mistahes ajal oma esiletõstetud teemaviiteid kohas <link>Muuda profiili > Esiletõstetud teemaviited</link>.",
  "featured_tags.suggestions.dismiss": "Ei, aitäh",
  "filter_modal.added.context_mismatch_explanation": "See filtrikategooria ei rakendu kontekstis, kuidas postituseni jõudsid. Kui tahad postitust ka selles kontekstis filtreerida, pead muutma filtrit.",
  "filter_modal.added.context_mismatch_title": "Konteksti mittesobivus!",
  "filter_modal.added.expired_explanation": "Selle filtri kategooria on aegunud. pead muutma aegumiskuupäeva, kui tahad, et filter kehtiks.",
  "filter_modal.added.expired_title": "Aegunud filter!",
  "filter_modal.added.review_and_configure": "Et vaadata üle ja täpsemalt seadistada seda filtrikategooriat, mine lehele {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filtrite sätted",
  "filter_modal.added.settings_link": "sätete leht",
  "filter_modal.added.short_explanation": "See postitus on lisatud järgmisesse filtrikategooriasse: {title}.",
  "filter_modal.added.title": "Filter lisatud!",
  "filter_modal.select_filter.context_mismatch": "ei avaldu selles kontekstis",
  "filter_modal.select_filter.expired": "aegunud",
  "filter_modal.select_filter.prompt_new": "Uus kategooria: {name}",
  "filter_modal.select_filter.search": "Otsi või loo",
  "filter_modal.select_filter.subtitle": "Kasuta olemasolevat kategooriat või loo uus",
  "filter_modal.select_filter.title": "Filtreeri seda postitust",
  "filter_modal.title.status": "Postituse filtreerimine",
  "filter_warning.matches_filter": "Sobib filtriga “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "{count, plural, =0 {Mitte üheltki inimeselt} one {Ühelt inimeselt} other {# inimeselt}}, keda võid teada",
  "filtered_notifications_banner.title": "Filtreeritud teavitused",
  "firehose.all": "Kõik",
  "firehose.local": "See server",
  "firehose.remote": "Teised serverid",
  "follow_request.authorize": "Autoriseeri",
  "follow_request.reject": "Hülga",
  "follow_requests.unlocked_explanation": "Kuigi su konto pole lukustatud, soovitab {domain} personal siiski nende kontode jälgimistaotlused käsitsi üle vaadata.",
  "follow_suggestions.curated_suggestion": "Meeskonna valitud",
  "follow_suggestions.dismiss": "Ära enam näita",
  "follow_suggestions.featured_longer": "Käsitsi valitud {domain} meeskonna poolt",
  "follow_suggestions.friends_of_friends_longer": "Populaarne inimeste hulgas, keda jälgid",
  "follow_suggestions.hints.featured": "Selle kasutajaprofiili on soovitanud {domain} meeskond.",
  "follow_suggestions.hints.friends_of_friends": "See kasutajaprofiil on sinu jälgitavate seas populaarne.",
  "follow_suggestions.hints.most_followed": "See on {domain} enim jälgitud kasutajaprofiil.",
  "follow_suggestions.hints.most_interactions": "See kasutajaprofiil on viimasel ajal {domain} saanud palju tähelepanu.",
  "follow_suggestions.hints.similar_to_recently_followed": "See kasutajaprofiil sarnaneb neile, mida oled hiljuti jälgima asunud.",
  "follow_suggestions.personalized_suggestion": "Isikupärastatud soovitus",
  "follow_suggestions.popular_suggestion": "Populaarne soovitus",
  "follow_suggestions.popular_suggestion_longer": "Populaarne kohas {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Sarnane profiilile, mida hiljuti jälgima hakkasid",
  "follow_suggestions.view_all": "Vaata kõiki",
  "follow_suggestions.who_to_follow": "Keda jälgida",
  "followed_tags": "Jälgitavad teemaviited",
  "followers.hide_other_followers": "See kasutaja eelistab mitte avaldada oma teisi jälgijaid",
  "followers.title": "{name} jälgimine",
  "following.hide_other_following": "See kasutaja eelistab mitte avaldada oma teisi jälgitavaid",
  "following.title": "Jälgitakse {name} poolt",
  "footer.about": "Teave",
  "footer.about_mastodon": "Mastodoni kohta",
  "footer.about_server": "{domain} kohta",
  "footer.about_this_server": "Serveri teave",
  "footer.directory": "Profiilikataloog",
  "footer.get_app": "Laadi rakendus",
  "footer.keyboard_shortcuts": "Kiirklahvid",
  "footer.privacy_policy": "Isikuandmete kaitse",
  "footer.source_code": "Lähtekood",
  "footer.status": "Olek",
  "footer.terms_of_service": "Kasutustingimused",
  "form_error.blank": "Väli ei tohi olla tühi.",
  "form_field.optional": "(valikuline)",
  "generic.saved": "Salvestatud",
  "getting_started.heading": "Alustamine",
  "hashtag.admin_moderation": "Ava modereerimisliides #{name} jaoks",
  "hashtag.browse": "Sirvi #{hashtag} teemaviitega postitusi",
  "hashtag.browse_from_account": "Sirvi @{name} kasutaja #{hashtag} teemaviitega postitusi",
  "hashtag.column_header.tag_mode.all": "ja {additional}",
  "hashtag.column_header.tag_mode.any": "või teemaviide {additional}",
  "hashtag.column_header.tag_mode.none": "ilma teemaviiteta {additional}",
  "hashtag.column_settings.select.no_options_message": "Soovitusi ei leitud",
  "hashtag.column_settings.select.placeholder": "Sisesta teemaviited…",
  "hashtag.column_settings.tag_mode.all": "Kõik need",
  "hashtag.column_settings.tag_mode.any": "Mõni neist",
  "hashtag.column_settings.tag_mode.none": "Mitte ükski neist",
  "hashtag.column_settings.tag_toggle": "Kaasa lisasildid selle veeru jaoks",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} osalejaga} other {{counter} osalejaga}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} postitusega} other {{counter} postitusega}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} postitust} other {{counter} postitust}} täna",
  "hashtag.feature": "Tõsta profiilis esile",
  "hashtag.follow": "Jälgi silti",
  "hashtag.mute": "Summuta teemaviide @#{hashtag}",
  "hashtag.unfeature": "Ära tõsta profiilis esile",
  "hashtag.unfollow": "Lõpeta sildi jälgimine",
  "hashtags.and_other": "…ja {count, plural, one {}other {# veel}}",
  "hints.profiles.followers_may_be_missing": "Selle profiili jälgijaid võib olla puudu.",
  "hints.profiles.follows_may_be_missing": "Selle profiili poolt jälgitavaid võib olla puudu.",
  "hints.profiles.posts_may_be_missing": "Mõned selle profiili postitused võivad olla puudu.",
  "hints.profiles.see_more_followers": "Vaata rohkem jälgijaid kohas {domain}",
  "hints.profiles.see_more_follows": "Vaata rohkem jälgitavaid kohas {domain}",
  "hints.profiles.see_more_posts": "Vaata rohkem postitusi kohas {domain}",
  "home.column_settings.show_quotes": "Näita tsiteeritut",
  "home.column_settings.show_reblogs": "Näita jagamisi",
  "home.column_settings.show_replies": "Näita vastuseid",
  "home.hide_announcements": "Peida teadaanded",
  "home.pending_critical_update.body": "Palun uuenda oma Mastodoni server nii ruttu kui võimalik!",
  "home.pending_critical_update.link": "Vaata uuendusi",
  "home.pending_critical_update.title": "Saadaval kriitiline turvauuendus!",
  "home.show_announcements": "Kuva teadaandeid",
  "ignore_notifications_modal.disclaimer": "Mastodon ei saa teavitada kasutajaid, et ignoreerisid nende teavitusi. Teavituste ignoreerimine ei peata sõnumite endi saatmist.",
  "ignore_notifications_modal.filter_instead": "Selle asemel filtreeri",
  "ignore_notifications_modal.filter_to_act_users": "Saad endiselt kasutajaid vastu võtta, tagasi lükata või neist teatada",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtreerimine aitab vältida võimalikke segaminiajamisi",
  "ignore_notifications_modal.filter_to_review_separately": "Saad filtreeritud teateid eraldi vaadata",
  "ignore_notifications_modal.ignore": "Ignoreeri teavitusi",
  "ignore_notifications_modal.limited_accounts_title": "Ignoreeri modereeritud kontode teavitusi?",
  "ignore_notifications_modal.new_accounts_title": "Ignoreeri uute kontode teavitusi?",
  "ignore_notifications_modal.not_followers_title": "Ignoreeri inimeste teavitusi, kes sind ei jälgi?",
  "ignore_notifications_modal.not_following_title": "Ignoreeri inimeste teavitusi, keda sa ei jälgi?",
  "ignore_notifications_modal.private_mentions_title": "Ignoreeri soovimatute eraviisiliste mainimiste teateid?",
  "info_button.label": "Abi",
  "info_button.what_is_alt_text": "<h1>Mis on alt-tekst?</h1> <p>Alt-tekst pakub pildi kirjeldust nägemispuudega inimeste jaoks või neile, kel on aeglane internet või neile, kes otsivad lisaselgitust</p> <p>Saad parandada ligipääsetavust ja mõistmist kõigi jaoks, kirjutades selge, lühida ja objektiivse alt-teksti.</p> <ul> <li>Lisa tähtsad elemendid</li> <li>Tee pildil olevast tekstist kokkuvõte</li> <li>Kasuta reeglipärast lausestruktuuri</li> <li>Väldi ebaolulist infot</li> <li>Keskendu keerukate vaadete puhul (näiteks diagrammid ja kaardid) puhul trendidele ja põhiseostele</li> </ul>",
  "interaction_modal.action": "Suhestumaks kasutaja {name} postitusega palun logi sisse oma Mastodoni kasutajakontoga sõltumata serverist, mida kasutad.",
  "interaction_modal.action_follow": "Jälgimaks kasutajat {name} pead sisenema oma kontole mistahes Mastodoni serveris, mida kasutad.",
  "interaction_modal.go": "Mine",
  "interaction_modal.no_account_yet": "Pole veel kontot?",
  "interaction_modal.on_another_server": "Teises serveris",
  "interaction_modal.on_this_server": "Selles serveris",
  "interaction_modal.title": "Jätkamiseks logi sisse",
  "interaction_modal.username_prompt": "Nt {example}",
  "intervals.full.days": "{number, plural, one {# päev} other {# päeva}}",
  "intervals.full.hours": "{number, plural, one {# tund} other {# tundi}}",
  "intervals.full.minutes": "{number, plural, one {# minut} other {# minutit}}",
  "keyboard_shortcuts.back": "Liigu tagasi",
  "keyboard_shortcuts.blocked": "Ava blokeeritud kasutajate nimistu",
  "keyboard_shortcuts.boost": "Jaga",
  "keyboard_shortcuts.column": "Fookus veerule",
  "keyboard_shortcuts.compose": "Fookus teksti koostamise alale",
  "keyboard_shortcuts.description": "Kirjeldus",
  "keyboard_shortcuts.direct": "Ava privaatsete mainimiste veerg",
  "keyboard_shortcuts.down": "Liigu loetelus alla",
  "keyboard_shortcuts.enter": "Ava postitus",
  "keyboard_shortcuts.explore": "Ava trendikate ajajoon",
  "keyboard_shortcuts.favourite": "Lemmikpostitus",
  "keyboard_shortcuts.favourites": "Ava lemmikute loetelu",
  "keyboard_shortcuts.federated": "Ava föderatsiooni ajajoon",
  "keyboard_shortcuts.heading": "Kiirklahvid",
  "keyboard_shortcuts.home": "Ava kodu ajajoon",
  "keyboard_shortcuts.hotkey": "Kiirklahv",
  "keyboard_shortcuts.legend": "Kuva see legend",
  "keyboard_shortcuts.load_more": "Fookus „Laadi veel“ nupule",
  "keyboard_shortcuts.local": "Ava kohalik ajajoon",
  "keyboard_shortcuts.mention": "Maini autorit",
  "keyboard_shortcuts.muted": "Ava summutatud kasutajate loetelu",
  "keyboard_shortcuts.my_profile": "Ava oma profiil",
  "keyboard_shortcuts.notifications": "Ava teadete veerg",
  "keyboard_shortcuts.open_media": "Ava meedia",
  "keyboard_shortcuts.pinned": "Ava esiletõstetud postituste loend",
  "keyboard_shortcuts.profile": "Ava autori profiil",
  "keyboard_shortcuts.quote": "Tsiteeri postitust",
  "keyboard_shortcuts.reply": "Vasta postitusele",
  "keyboard_shortcuts.requests": "Ava jälgimistaotluste loetelu",
  "keyboard_shortcuts.search": "Fookus otsingule",
  "keyboard_shortcuts.spoilers": "Näita/peida hoiatuse väli",
  "keyboard_shortcuts.start": "Ava veerg \"Alusta\"",
  "keyboard_shortcuts.toggle_hidden": "Näita/peida teksti hoiatuse taga",
  "keyboard_shortcuts.toggle_sensitivity": "Näita/peida meediat",
  "keyboard_shortcuts.toot": "Alusta uut postitust",
  "keyboard_shortcuts.top": "Tõsta loendi algusesse",
  "keyboard_shortcuts.translate": "postituse tõlkimiseks",
  "keyboard_shortcuts.unfocus": "Fookus tekstialalt/otsingult ära",
  "keyboard_shortcuts.up": "Liigu loetelus üles",
  "learn_more_link.got_it": "Sain aru",
  "learn_more_link.learn_more": "Lisateave",
  "lightbox.close": "Sulge",
  "lightbox.next": "Järgmine",
  "lightbox.previous": "Eelmine",
  "lightbox.zoom_in": "Näita algsuuruses",
  "lightbox.zoom_out": "Näita kõik",
  "limited_account_hint.action": "Näita profilli sellegipoolest",
  "limited_account_hint.title": "See profiil on peidetud {domain} moderaatorite poolt.",
  "link_preview.author": "{name} poolt",
  "link_preview.more_from_author": "Veel kasutajalt {name}",
  "link_preview.shares": "{count, plural, one {{counter} postitus} other {{counter} postitust}}",
  "lists.add_member": "Lisa",
  "lists.add_to_list": "Lisa loendisse",
  "lists.add_to_lists": "Lisa {name} loetellu",
  "lists.create": "Loo",
  "lists.create_a_list_to_organize": "Loo uus loetelu, et organiseerida oma avalehe lõime",
  "lists.create_list": "Loo loetelu",
  "lists.delete": "Kustuta loetelu",
  "lists.done": "Valmis",
  "lists.edit": "Muuda loetelu",
  "lists.exclusive": "Peida avalehelt liikmed",
  "lists.exclusive_hint": "Kui keegi on selles loetelus, peida ta avalehe lõimest, vältimaks tema postituste kaks korda nägemist.",
  "lists.find_users_to_add": "Leia kasutajaid, keda lisada",
  "lists.list_members_count": "{count, plural, one {# liige} other {# liiget}}",
  "lists.list_name": "Loetelu nimi",
  "lists.new_list_name": "Loetelu uus nimi",
  "lists.no_lists_yet": "Pole veel loetelusid.",
  "lists.no_members_yet": "Pole veel liikmeid.",
  "lists.no_results_found": "Ei leidnud tulemusi.",
  "lists.remove_member": "Eemalda",
  "lists.replies_policy.followed": "Igalt jälgitud kasutajalt",
  "lists.replies_policy.list": "Loetelu liikmetelt",
  "lists.replies_policy.none": "Mitte kelleltki",
  "lists.save": "Salvesta",
  "lists.search": "Otsi",
  "lists.show_replies_to": "Kaasa ka loetelu liikmete vastused",
  "load_pending": "{count, plural, one {# uus kirje} other {# uut kirjet}}",
  "loading_indicator.label": "Laadimine…",
  "media_gallery.hide": "Peida",
  "moved_to_account_banner.text": "Kontot {disabledAccount} ei ole praegu võimalik kasutada, sest kolisid kontole {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Peida teavituste hulgast",
  "mute_modal.hide_options": "Peida valikud",
  "mute_modal.indefinite": "Kuni eemaldan neilt summutamise",
  "mute_modal.show_options": "Kuva valikud",
  "mute_modal.they_can_mention_and_follow": "Ta saab sind mainida ja sind jälgida, kuid sa ei näe teda.",
  "mute_modal.they_wont_know": "Ta ei tea, et ta on summutatud.",
  "mute_modal.title": "Kas summutad kasutaja?",
  "mute_modal.you_wont_see_mentions": "Sa ei näe postitusi, mis teda mainivad.",
  "mute_modal.you_wont_see_posts": "Ta näeb jätkuvalt sinu postitusi, kuid sa ei näe tema omi.",
  "navigation_bar.about": "Teave",
  "navigation_bar.account_settings": "Salasõna ja turvalisus",
  "navigation_bar.administration": "Administreerimine",
  "navigation_bar.advanced_interface": "Ava kohandatud veebiliides",
  "navigation_bar.automated_deletion": "Postituste automaatne kustutamine",
  "navigation_bar.blocks": "Blokeeritud kasutajad",
  "navigation_bar.bookmarks": "Järjehoidjad",
  "navigation_bar.collections": "Kogumikud",
  "navigation_bar.direct": "Privaatsed mainimised",
  "navigation_bar.domain_blocks": "Peidetud domeenid",
  "navigation_bar.favourites": "Lemmikud",
  "navigation_bar.filters": "Summutatud sõnad",
  "navigation_bar.follow_requests": "Jälgimistaotlused",
  "navigation_bar.followed_tags": "Jälgitavad teemaviited",
  "navigation_bar.follows_and_followers": "Jälgitavad ja jälgijad",
  "navigation_bar.import_export": "Import ja eksport",
  "navigation_bar.lists": "Loetelud",
  "navigation_bar.live_feed_local": "Ajajoon reaalajas (sinu server)",
  "navigation_bar.live_feed_public": "Ajajoon reaalajas (Födiversum)",
  "navigation_bar.logout": "Logi välja",
  "navigation_bar.moderation": "Modereerimine",
  "navigation_bar.more": "Lisavalikud",
  "navigation_bar.mutes": "Summutatud kasutajad",
  "navigation_bar.opened_in_classic_interface": "Postitused, kontod ja teised spetsiaalsed lehed avatakse vaikimisi klassikalises veebiliideses.",
  "navigation_bar.preferences": "Eelistused",
  "navigation_bar.privacy_and_reach": "Privaatsus ja ulatus",
  "navigation_bar.search": "Otsing",
  "navigation_bar.search_trends": "Otsi / Populaarsust koguv",
  "navigation_panel.collapse_followed_tags": "Ahenda jälgitavate teemaviidete menüü",
  "navigation_panel.collapse_lists": "Ahenda loendimenüü",
  "navigation_panel.expand_followed_tags": "Ava jälgitavate teemaviidete menüü",
  "navigation_panel.expand_lists": "Laienda loendimenüüd",
  "not_signed_in_indicator.not_signed_in": "Pead sisse logima, et saada ligipääsu sellele ressursile.",
  "notification.added_to_collection": "{name} lisas sind kogumikku",
  "notification.admin.report": "{name} saatis teavituse {target} kohta",
  "notification.admin.report_account": "{name} raporteeris {count, plural, one {ühest postitusest} other {# postitusest}} kohast {target} kategooriast {category}",
  "notification.admin.report_account_other": "{name} raporteeris {count, plural, one {ühest postitusest} other {# postitusest}} kohast {target}",
  "notification.admin.report_statuses": "{name} raporteeris {target} kategooriast {category}",
  "notification.admin.report_statuses_other": "{name} raporteeris kohast {target}",
  "notification.admin.sign_up": "{name} registreerus",
  "notification.admin.sign_up.name_and_others": "{name} ja {count, plural, one {# veel} other {# teist}} liitus",
  "notification.annual_report.message": "Sinu {year} #Wrapstodon ootab! Avalda oma aasta tipphetked ja meeldejäävad hetked Mastodonis!",
  "notification.annual_report.view": "Vaata #Wrapstodon",
  "notification.collection_update": "{name} muutis kogumikku, kuhu sa kuulud",
  "notification.favourite": "{name} märkis su postituse lemmikuks",
  "notification.favourite.name_and_others_with_link": "{name} ja <a>{count, plural, one {# veel} other {# teist}}</a> märkis su postituse lemmikuks",
  "notification.favourite_pm": "{name} märkis sinu privaatse mainimise lemmikuks",
  "notification.favourite_pm.name_and_others_with_link": "{name} ja <a>{count, plural, one {# veel} other {# veel}}</a> märkisid su privaatse mainimise lemmikuks",
  "notification.follow": "{name} alustas su jälgimist",
  "notification.follow.name_and_others": "{name} ja veel {count, plural, one {# kasutaja} other {# kasutajat}} hakkas sind jälgima",
  "notification.follow_request": "{name} soovib sind jälgida",
  "notification.follow_request.name_and_others": "{name} ja {count, plural, one {# veel} other {# teist}} taotles sinu jälgimist",
  "notification.label.mention": "Mainimine",
  "notification.label.private_mention": "Privaatne mainimine",
  "notification.label.private_reply": "Privaatne vastus",
  "notification.label.quote": "{name} tsiteeris sinu postitust",
  "notification.label.reply": "Vastus",
  "notification.mention": "Mainimine",
  "notification.mentioned_you": "{name} mainis sind",
  "notification.moderation-warning.learn_more": "Vaata lisa",
  "notification.moderation_warning": "Said modereerimise hoiatuse",
  "notification.moderation_warning.action_delete_statuses": "Mõni su postitus on eemaldatud.",
  "notification.moderation_warning.action_disable": "Su konto on keelatud.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Mõni su postitustest on märgitud kui tundlik.",
  "notification.moderation_warning.action_none": "Su konto on saanud modereerimise hoiatuse.",
  "notification.moderation_warning.action_sensitive": "Su postitused märgitakse nüüdsest tundlikuks.",
  "notification.moderation_warning.action_silence": "Su kontole pandi piirang.",
  "notification.moderation_warning.action_suspend": "Su konto on peatatud.",
  "notification.own_poll": "Su küsitlus on lõppenud",
  "notification.poll": "Hääletus, millel osalesid, on lõppenud",
  "notification.quoted_update": "{name} on muutnud sinu poolt tsiteeritud postitust",
  "notification.reblog": "{name} jagas edasi postitust",
  "notification.reblog.name_and_others_with_link": "{name} ja <a>{count, plural, one {# veel} other {# teist}}</a> jagas su postitust",
  "notification.relationships_severance_event": "Kadunud ühendus kasutajaga {name}",
  "notification.relationships_severance_event.account_suspension": "{from} admin on kustutanud {target}, mis tähendab, et sa ei saa enam neilt uuendusi või suhelda nendega.",
  "notification.relationships_severance_event.domain_block": "{from} admin on blokeerinud {target}, sealhulgas {followersCount} sinu jälgijat ja {followingCount, plural, one  {# konto} other {# kontot}}, mida jälgid.",
  "notification.relationships_severance_event.learn_more": "Vaata lisa",
  "notification.relationships_severance_event.user_domain_block": "Blokeerisid {target}, eemaldades oma jälgijate hulgast {followersCount} ja jälgitavate hulgast {followingCount, plural, one {# konto} other {# kontot}}.",
  "notification.status": "{name} just postitas",
  "notification.update": "{name} muutis postitust",
  "notification_requests.accept": "Nõus",
  "notification_requests.accept_multiple": "{count, plural, one {Nõustu # taotlusega…} other {Nõustu # taotlusega…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Nõustu taotlusega} other {Nõustu taotlustega}}",
  "notification_requests.confirm_accept_multiple.message": "Oled nõustumas {count, plural, one {ühe teavituse taotlusega} other {# teavituse taotlusega}}. Oled kindel, et soovid jätkata?",
  "notification_requests.confirm_accept_multiple.title": "Nõustuda teavituste taotlustega?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Loobu taotlusest} other {Loobu taotlustest}}",
  "notification_requests.confirm_dismiss_multiple.message": "Oled loobumas {count, plural, one {ühest teavituse taotlusest} other {# teavituse taotlusest}}. {count, plural, one {Sellele} other {Neile}} pole hiljem lihtne ligi pääseda. Oled kindel, et soovid jätkata?",
  "notification_requests.confirm_dismiss_multiple.title": "Hüljata teavituse taotlused?",
  "notification_requests.dismiss": "Hülga",
  "notification_requests.dismiss_multiple": "{count, plural, one {Loobuda # taotlusest…} other {Loobuda # taotlusest…}}",
  "notification_requests.edit_selection": "Muuda",
  "notification_requests.exit_selection": "Valmis",
  "notification_requests.explainer_for_limited_account": "Sellelt kontolt tulevad teavitused on filtreeritud, sest moderaator on seda kontot piiranud.",
  "notification_requests.explainer_for_limited_remote_account": "Sellelt kontolt tulevad teavitused on filtreeritud, sest moderaator on seda kontot või serverit piiranud.",
  "notification_requests.maximize": "Maksimeeri",
  "notification_requests.minimize_banner": "Minimeeri filtreeritud teavituste bänner",
  "notification_requests.notifications_from": "Teavitus kasutajalt {name}",
  "notification_requests.title": "Filtreeritud teavitused",
  "notification_requests.view": "Vaata teavitusi",
  "notifications.clear": "Puhasta teated",
  "notifications.clear_confirmation": "Oled kindel, et soovid püsivalt kõik oma teated eemaldada?",
  "notifications.clear_title": "Tühjenda teavitus?",
  "notifications.column_settings.admin.report": "Uued teavitused:",
  "notifications.column_settings.admin.sign_up": "Uued kasutajad:",
  "notifications.column_settings.alert": "Töölauateated",
  "notifications.column_settings.favourite": "Lemmikud:",
  "notifications.column_settings.filter_bar.advanced": "Näita kõiki kategooriaid",
  "notifications.column_settings.filter_bar.category": "Kiirfiltri riba",
  "notifications.column_settings.follow": "Uued jälgijad:",
  "notifications.column_settings.follow_request": "Uued jälgimistaotlused:",
  "notifications.column_settings.group": "Grupp",
  "notifications.column_settings.mention": "Mainimised:",
  "notifications.column_settings.poll": "Küsitluse tulemused:",
  "notifications.column_settings.push": "Push teated",
  "notifications.column_settings.quote": "Tsitaadid:",
  "notifications.column_settings.reblog": "Jagamised:",
  "notifications.column_settings.show": "Kuva tulbas",
  "notifications.column_settings.sound": "Mängi heli",
  "notifications.column_settings.status": "Uued postitused:",
  "notifications.column_settings.unread_notifications.category": "Lugemata teated",
  "notifications.column_settings.unread_notifications.highlight": "Tõsta esile lugemata teated",
  "notifications.column_settings.update": "Muudatused:",
  "notifications.filter.all": "Kõik",
  "notifications.filter.boosts": "Jagamised",
  "notifications.filter.favourites": "Lemmikud",
  "notifications.filter.follows": "Jälgib",
  "notifications.filter.mentions": "Mainimised",
  "notifications.filter.polls": "Küsitluse tulemused",
  "notifications.filter.statuses": "Uuendused inimestelt, keda jälgid",
  "notifications.grant_permission": "Anna luba.",
  "notifications.group": "{count} teated",
  "notifications.mark_as_read": "Märgi kõik teated loetuks",
  "notifications.permission_denied": "Töölauamärguanded pole saadaval, kuna eelnevalt keelduti lehitsejale teavituste luba andmast",
  "notifications.permission_denied_alert": "Töölaua märguandeid ei saa lubada, kuna brauseri luba on varem keeldutud",
  "notifications.permission_required": "Töölaua märguanded ei ole saadaval, kuna vajalik luba pole antud.",
  "notifications.policy.accept": "Nõustun",
  "notifications.policy.accept_hint": "Näita teavitustes",
  "notifications.policy.drop": "Ignoreeri",
  "notifications.policy.drop_hint": "Saada tühjusse, mitte kunagi seda enam näha",
  "notifications.policy.filter": "Filter",
  "notifications.policy.filter_hint": "Saadetud filtreeritud teavituste sisendkasti",
  "notifications.policy.filter_limited_accounts_hint": "Piiratud serveri moderaatorite poolt",
  "notifications.policy.filter_limited_accounts_title": "Modereeritud kontod",
  "notifications.policy.filter_new_accounts.hint": "Loodud viimase {days, plural, one {ühe päeva} other {# päeva}} jooksul",
  "notifications.policy.filter_new_accounts_title": "Uued kontod",
  "notifications.policy.filter_not_followers_hint": "Kaasates kasutajad, kes on sind jälginud vähem kui {days, plural, one {ühe päeva} other {# päeva}}",
  "notifications.policy.filter_not_followers_title": "Sind mittejälgivad kasutajad",
  "notifications.policy.filter_not_following_hint": "Kuni sa nad käsitsi kinnitad",
  "notifications.policy.filter_not_following_title": "Inimesed, keda sa ei jälgi",
  "notifications.policy.filter_private_mentions_hint": "Filtreeritud, kui see pole vastus sinupoolt mainimisele või kui jälgid saatjat",
  "notifications.policy.filter_private_mentions_title": "Soovimatud privaatsed mainimised",
  "notifications.policy.title": "Halda teavitusi kohast…",
  "notifications_permission_banner.enable": "Luba töölaua märguanded",
  "notifications_permission_banner.how_to_control": "Et saada teateid, ajal mil Mastodon pole avatud, luba töölauamärguanded. Saad täpselt määrata, mis tüüpi tegevused tekitavad märguandeid, kasutates peale teadaannete sisse lülitamist üleval olevat nuppu {icon}.",
  "notifications_permission_banner.title": "Ära jää millestki ilma",
  "onboarding.follows.back": "Tagasi",
  "onboarding.follows.empty": "Kahjuks ei saa hetkel tulemusi näidata. Proovi kasutada otsingut või lehitse uurimise lehte, et leida inimesi, keda jälgida, või proovi hiljem uuesti.",
  "onboarding.follows.next": "Järgmine: Seadista oma profiil",
  "onboarding.follows.search": "Otsi",
  "onboarding.follows.title": "Jälgi inimesi, et alustada",
  "onboarding.profile.discoverable": "Muuda mu profiil avastatavaks",
  "onboarding.profile.discoverable_hint": "Kui nõustud enda avastamisega Mastodonis, võivad sinu postitused ilmuda otsingutulemustes ja trendides ning sinu profiili võidakse soovitada sinuga sarnaste huvidega inimestele.",
  "onboarding.profile.display_name": "Näidatav nimi",
  "onboarding.profile.display_name_hint": "Su täisnimi või naljanimi…",
  "onboarding.profile.finish": "Valmis",
  "onboarding.profile.note": "Elulugu",
  "onboarding.profile.note_hint": "Saad @mainida teisi kasutajaid või lisada #teemaviiteid…",
  "onboarding.profile.title": "Profiili seadistamine",
  "onboarding.profile.upload_avatar": "Laadi üles profiilipilt",
  "onboarding.profile.upload_header": "Laadi üles profiili päis",
  "password_confirmation.exceeds_maxlength": "Salasõnakinnitus on pikem kui salasõna maksimumpikkus",
  "password_confirmation.mismatching": "Salasõnad ei klapi",
  "picture_in_picture.restore": "Pane tagasi",
  "poll.closed": "Suletud",
  "poll.refresh": "Värskenda",
  "poll.reveal": "Tulemused",
  "poll.total_people": "{count, plural,one {# inimene} other {# inimest}}",
  "poll.total_votes": "{count, plural, one {# hääl} other {# häält}}",
  "poll.vote": "Hääleta",
  "poll.voted": "Hääletasid selle poolt",
  "poll.votes": "{votes, plural, one {# hääl} other {# häält}}",
  "poll_button.add_poll": "Lisa küsitlus",
  "poll_button.remove_poll": "Eemalda küsitlus",
  "privacy.change": "Muuda postituse nähtavust",
  "privacy.direct.long": "Kõik postituses mainitud",
  "privacy.direct.short": "Privaatne mainimine",
  "privacy.private.long": "Ainult jälgijad",
  "privacy.private.short": "Jälgijad",
  "privacy.public.long": "Nii kasutajad kui mittekasutajad",
  "privacy.public.short": "Avalik",
  "privacy.quote.anyone": "{visibility}, tsiteerimine on lubatud",
  "privacy.quote.disabled": "{visibility}, tsiteerimine pole lubatud",
  "privacy.quote.limited": "{visibility}, tsiteerimine on piiratud",
  "privacy.unlisted.additional": "See on olemuselt küll avalik, aga postitus ei ilmu voogudes ega teemaviidetes, lehitsedes ega Mastodoni otsingus, isegi kui konto on seadistustes avalik.",
  "privacy.unlisted.long": "Peidetud Mastodoni otsingutulemustest, pupulaarsust koguva sisu voost ja avalikult ajajoonelt",
  "privacy.unlisted.short": "Vaikselt avalik",
  "privacy_policy.last_updated": "Viimati uuendatud {date}",
  "privacy_policy.title": "Isikuandmete kaitse",
  "quote_error.edit": "Postituse muutmisel ei saa tsitaati lisada.",
  "quote_error.poll": "Tsiteerimine pole küsitlustes lubatud.",
  "quote_error.private_mentions": "Tsiteerimine pole otsemainimiste puhul lubatud.",
  "quote_error.quote": "Korraga on lubatud vaid üks tsitaat.",
  "quote_error.unauthorized": "Sul pole õigust seda postitust tsiteerida.",
  "quote_error.upload": "Tsiteerimine pole manuste puhul lubatud.",
  "recommended": "Soovitatud",
  "refresh": "Värskenda",
  "regeneration_indicator.please_stand_by": "Palun oota.",
  "regeneration_indicator.preparing_your_home_feed": "Valmistan ette sinu avalehe lõime…",
  "relative_time.days": "{number}p",
  "relative_time.full.days": "{number, plural, one {# päev} other {# päeva}} tagasi",
  "relative_time.full.hours": "{number, plural, one {# tund} other {# tundi}} tagasi",
  "relative_time.full.just_now": "just nüüd",
  "relative_time.full.minutes": "{number, plural, one {# minut} other {# minutit}} tagasi",
  "relative_time.full.seconds": "{number, plural, one {# sekund} other {# sekundit}} tagasi",
  "relative_time.hours": "{number}t",
  "relative_time.just_now": "nüüd",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "täna",
  "remove_quote_hint.button_label": "Sain aru",
  "remove_quote_hint.message": "Sa saad teha seda {icon} eelistuste menüüst.",
  "remove_quote_hint.title": "Kas sa soovid oma tsiteeritud postituse eemaldada?",
  "reply_indicator.attachments": "{count, plural, one {# lisa} other {# lisa}}",
  "reply_indicator.cancel": "Tühista",
  "reply_indicator.poll": "Küsitlus",
  "report.block": "Blokeeri",
  "report.block_explanation": "Sa ei näe tema postitusi. Tema ei saa näha sinu postitusi ega sind jälgida. Talle on näha, et ta on blokeeritud.",
  "report.categories.legal": "Juriidiline",
  "report.categories.other": "Muud",
  "report.categories.spam": "Rämpspost",
  "report.categories.violation": "Sisu, mis rikub ühte või enamat serveri reeglit",
  "report.category.subtitle": "Vali parim vaste",
  "report.category.title": "Selgita, mis on selle {type} valesti",
  "report.category.title_account": "kontoga",
  "report.category.title_status": "postitusega",
  "report.close": "Valmis",
  "report.collection_comment": "Miks soovid sellest kogumikust raporteerida?",
  "report.comment.title": "Kas arvad, et on veel midagi, mida me peaks teadma?",
  "report.forward": "Edasta ka {target} domeeni",
  "report.forward_hint": "See kasutaja on teisest serverist. Kas saadan anonümiseeritud koopia sellest teatest sinna ka?",
  "report.mute": "Summuta",
  "report.mute_explanation": "Sa ei näe tema postitusi. Ta võib ikka sind jälgida ja su postitusi näha. Ta ei saa teada, et ta on summutatud.",
  "report.next": "Järgmine",
  "report.placeholder": "Lisaks kommentaarid",
  "report.reasons.dislike": "Mulle ei meeldi see",
  "report.reasons.dislike_description": "See on midagi sellist, mida sa näha ei taha",
  "report.reasons.legal": "See on ebaseaduslik",
  "report.reasons.legal_description": "Sa usud, et see rikub sinu või serveri asukohamaa seadust",
  "report.reasons.other": "Midagi muud",
  "report.reasons.other_description": "Probleem ei sobi teistesse kategooriatesse",
  "report.reasons.spam": "See on rämpspost",
  "report.reasons.spam_description": "Pahatahtlikud lingid, võltssuhtlus või korduvad vastused",
  "report.reasons.violation": "Rikub serveri reegleid",
  "report.reasons.violation_description": "Tead, et see rikub teatud reegleid",
  "report.rules.subtitle": "Vali kõik, mis sobivad",
  "report.rules.title": "Milliseid reegleid rikutakse?",
  "report.statuses.subtitle": "Vali kõik, mis sobivad",
  "report.statuses.title": "Kas on olemas postitusi, mis on sellele teavitusele tõenduseks?",
  "report.submission_error": "Raportit ei saanud saata",
  "report.submission_error_details": "Palun kontrolli internetiühendust ja proovi hiljem uuesti.",
  "report.submit": "Esita",
  "report.target": "Teatamine {target} kohta",
  "report.thanks.take_action": "Need on su võimalused määrata, mida Mastodonis näed:",
  "report.thanks.take_action_actionable": "Kuniks me seda üle vaatame, võid @{name} vastu teha need tegevused:",
  "report.thanks.title": "Ei taha seda näha?",
  "report.thanks.title_actionable": "Täname teavitamise eest, uurime seda.",
  "report.unfollow": "Lõpeta @{name} jälgimine",
  "report.unfollow_explanation": "Jälgid seda kontot. Et mitte näha tema postitusi oma avalehe lõimes, lõpeta ta jälgimine.",
  "report_notification.attached_statuses": "{count, plural, one {{count} postitus} other {{count} postitust}} listatud",
  "report_notification.categories.legal": "Õiguslik",
  "report_notification.categories.legal_sentence": "ebaseaduslik sisu",
  "report_notification.categories.other": "Muu",
  "report_notification.categories.other_sentence": "muu",
  "report_notification.categories.spam": "Rämpspost",
  "report_notification.categories.spam_sentence": "rämps",
  "report_notification.categories.violation": "Reeglite rikkumine",
  "report_notification.categories.violation_sentence": "reeglite rikkumine",
  "report_notification.open": "Ava teavitus",
  "search.clear": "Tühjenda otsing",
  "search.no_recent_searches": "Pole viimatisi otsinguid",
  "search.placeholder": "Otsi",
  "search.quick_action.account_search": "Sobivaid profiile {x}",
  "search.quick_action.go_to_account": "Mine profiili {x}",
  "search.quick_action.go_to_hashtag": "Ava teemaviide {x}",
  "search.quick_action.open_url": "Ava URL Mastodonis",
  "search.quick_action.status_search": "Sobivad postitused {x}",
  "search.search_or_paste": "Otsi või kleebi URL",
  "search_popout.full_text_search_disabled_message": "Pole saadaval kohas {domain}.",
  "search_popout.full_text_search_logged_out_message": "Saadaval vaid kui sisse logitud.",
  "search_popout.language_code": "Keele ISO-kood",
  "search_popout.options": "Otsimisvalikud",
  "search_popout.quick_actions": "Kiirtegevused",
  "search_popout.recent": "Viimatised otsingud",
  "search_popout.specific_date": "kindel päev",
  "search_popout.user": "kasutaja",
  "search_results.accounts": "Profiilid",
  "search_results.all": "Kõik",
  "search_results.hashtags": "Teemaviited",
  "search_results.no_results": "Tulemusi pole.",
  "search_results.no_search_yet": "Proovi otsida postitusi, profiile või teemaviiteid.",
  "search_results.see_all": "Vaata kõiki",
  "search_results.statuses": "Postitused",
  "search_results.title": "Otsi märksõna: {q}",
  "server_banner.about_active_users": "Inimesed, kes kasutavad seda serverit viimase 30 päeva jooksul (kuu aktiivsed kasutajad)",
  "server_banner.active_users": "aktiivset kasutajaid",
  "server_banner.administered_by": "Administraator:",
  "server_banner.is_one_of_many": "{domain} on üks paljudest sõltumatutest Mastodoni serveritest, mida saab fediversumis osalemiseks kasutada.",
  "server_banner.more_about_this_server": "Rohkem selle serveri kohta",
  "server_banner.server_stats": "Serveri statistika:",
  "sign_in_banner.create_account": "Loo konto",
  "sign_in_banner.follow_anyone": "Jälgi ükskõik keda kogu fediversumist ja näe kõike ajalises järjestuses. Ei mingeid algoritme, reklaame või klikipüüdjaid segamas.",
  "sign_in_banner.mastodon_is": "Mastodon on parim viis olemaks kursis sellega, mis toimub.",
  "sign_in_banner.sign_in": "Logi sisse",
  "sign_in_banner.sso_redirect": "Sisene või registreeru",
  "skip_links.hotkey": "<span>Kiirklahv</span> {hotkey}",
  "skip_links.skip_to_content": "Hüppa põhisisuni",
  "skip_links.skip_to_navigation": "Hüppa peamise navigeerimisalani",
  "status.admin_account": "Ava @{name} moderaatorivaates",
  "status.admin_domain": "Ava {domain} modeereerimisliides",
  "status.admin_status": "Ava postitus moderaatorivaates",
  "status.all_disabled": "Hooandmine ja tsiteerimine pole lubatud",
  "status.block": "Blokeeri @{name}",
  "status.bookmark": "Järjehoidja",
  "status.cancel_reblog_private": "Lõpeta jagamine",
  "status.cannot_quote": "Sul pole õigust seda postitust tsiteerida",
  "status.cannot_reblog": "Seda postitust ei saa jagada",
  "status.contains_quote": "Sisaldab tsitaati",
  "status.context.loading": "Laadin veel vastuseid",
  "status.context.loading_error": "Uute vastuste laadimine ei õnnestunud",
  "status.context.loading_success": "Uued vastused on laaditud",
  "status.context.more_replies_found": "Leidub veel vastuseid",
  "status.context.retry": "Proovi uuesti",
  "status.context.show": "Näita",
  "status.continued_thread": "Jätkatud lõim",
  "status.copy": "Kopeeri postituse link",
  "status.delete": "Kustuta",
  "status.delete.success": "Postitus on kustutatud",
  "status.detailed_status": "Detailne vestluskuva",
  "status.direct": "Maini privaatselt @{name}",
  "status.direct_indicator": "Privaatne mainimine",
  "status.edit": "Muuda",
  "status.edited": "Viimati muudetud {date}",
  "status.edited_x_times": "Muudetud {count, plural, one{{count} kord} other {{count} korda}}",
  "status.embed": "Hangi manustamiskood",
  "status.favourite": "Lemmik",
  "status.favourites_count": "{count, plural, one {{counter} lemmik} other {{counter} lemmikut}}",
  "status.filter": "Filtreeri seda postitust",
  "status.history.created": "{name} lõi {date}",
  "status.history.edited": "{name} muutis {date}",
  "status.load_more": "Laadi veel",
  "status.media.open": "Avamiseks klõpsa",
  "status.media.show": "Näitamiseks klõpsa",
  "status.media_hidden": "Meedia peidetud",
  "status.mention": "Maini @{name}'i",
  "status.more": "Veel",
  "status.mute": "Summuta @{name}",
  "status.mute_conversation": "Summuta vestlus",
  "status.open": "Laienda postitus",
  "status.pin": "Kinnita profiilile",
  "status.quote": "Tsiteeri",
  "status.quote.cancel": "Katkesta tsiteerimine",
  "status.quote_error.blocked_account_hint.title": "Kuna sa oled blokeerinud kasutaja @{name}, siis see postitus on peidetud.",
  "status.quote_error.blocked_domain_hint.title": "Kuna sa oled blokeerinud domeeni @{domain}, siis see postitus on peidetud.",
  "status.quote_error.filtered": "Peidetud mõne kasutatud filtri tõttu",
  "status.quote_error.limited_account_hint.action": "Näita ikkagi",
  "status.quote_error.limited_account_hint.title": "See profiil on peidetud {domain} serveri moderaatorite poolt.",
  "status.quote_error.muted_account_hint.title": "Kuna sa oled summutanud kasutaja @{name}, siis see postitus on peidetud.",
  "status.quote_error.not_available": "Postitus pole saadaval",
  "status.quote_error.pending_approval": "Postitus on ootel",
  "status.quote_error.pending_approval_popout.body": "Mastodonis saad sa kontrollida seda, kes võib sind tsiteerida. See postitus on seni ootel, kuni pole algse autori kinnitust tsiteerimisele.",
  "status.quote_error.revoked": "Autor on postituse eemaldanud",
  "status.quote_followers_only": "Vaid jälgijad saavad seda postitust tsiteerida",
  "status.quote_manual_review": "Autor vaatab selle üle",
  "status.quote_noun": "Tsitaat",
  "status.quote_policy_change": "Muuda neid, kes võivad tsiteerida",
  "status.quote_post_author": "Tsiteeris kasutaja @{name} postitust",
  "status.quote_private": "Otsepostituste tsiteerimine pole võimalik",
  "status.quotes.empty": "Keegi pole seda postitust veel tsiteerinud. Kui keegi seda teeb, siis on ta nähtav siin.",
  "status.quotes.local_other_disclaimer": "Autori poolt tagasilükatud tsitaate ei kuvata.",
  "status.quotes.remote_other_disclaimer": "Kui kasutaja on {domain} domeenist, siis siin on tagatud vaid tema tsitaatide näitamine. Autori poolt tagasilükatud tsitaate ei kuvata.",
  "status.quotes_count": "{count, plural, one {{counter} tsiteerimine} other {{counter} tsiteerimist}}",
  "status.read_more": "Loe veel",
  "status.reblog": "Jaga",
  "status.reblog_or_quote": "Anna hoogu või tsiteeri",
  "status.reblog_private": "Jaga uuesti oma jälgijatele",
  "status.reblogged_by": "{name} jagas",
  "status.reblogs.empty": "Keegi pole seda postitust veel jaganud. Kui keegi seda teeb, siis on ta nähtav siin.",
  "status.reblogs_count": "{count, plural, one {{counter} jagamine} other {{counter} jagamist}}",
  "status.redraft": "Kustuta & alga uuesti",
  "status.remove_bookmark": "Eemalda järjehoidja",
  "status.remove_favourite": "Eemalda lemmikute seast",
  "status.remove_quote": "Eemalda",
  "status.replied_in_thread": "Vastatud lõimes",
  "status.replied_to": "Vastas kasutajale {name}",
  "status.reply": "Vasta",
  "status.replyAll": "Vasta lõimele",
  "status.report": "Raporteeri @{name}",
  "status.request_quote": "Küsi võimalust tsiteerida",
  "status.revoke_quote": "Eemalda minu tsitaat postituses, mille tegi @{name}",
  "status.sensitive_warning": "Tundlik sisu",
  "status.share": "Jaga",
  "status.show_less_all": "Peida kogu tundlik sisu",
  "status.show_more_all": "Näita kogu tundlikku sisu",
  "status.show_original": "Näita algset",
  "status.title.with_attachments": "{user} postitas {attachmentCount, plural, one {manuse} other {{attachmentCount} manust}}",
  "status.translate": "Tõlgi",
  "status.translated_from_with": "Tõlgitud {lang} keelest kasutades teenust {provider}",
  "status.uncached_media_warning": "Eelvaade pole saadaval",
  "status.unmute_conversation": "Lõpeta vestluse summutamine",
  "status.unpin": "Eemalda profiilile kinnitus",
  "subscribed_languages.lead": "Pärast muudatust näed koduvaates ja loetelude ajajoontel postitusi valitud keeltes. Ära vali midagi, kui tahad näha postitusi kõikides keeltes.",
  "subscribed_languages.save": "Salvesta muudatused",
  "subscribed_languages.target": "Muuda tellitud keeli {target} jaoks",
  "tabs_bar.home": "Kodu",
  "tabs_bar.menu": "Menüü",
  "tabs_bar.notifications": "Teated",
  "tabs_bar.publish": "Uus postitus",
  "tabs_bar.search": "Otsing",
  "tag.remove": "Eemalda",
  "terms_of_service.effective_as_of": "Kehtib alates {date}",
  "terms_of_service.title": "Teenuse tingimused",
  "terms_of_service.upcoming_changes_on": "Muudatused alates {date}",
  "time_remaining.days": "{number, plural, one {# päev} other {# päeva}} jäänud",
  "time_remaining.hours": "{number, plural, one {# tund} other {# tundi}} jäänud",
  "time_remaining.minutes": "{number, plural, one {# minut} other {# minutit}} jäänud",
  "time_remaining.moments": "Hetked jäänud",
  "time_remaining.seconds": "{number, plural, one {# sekund} other {# sekundit}} jäänud",
  "trends.counter_by_accounts": "{count, plural, one {{counter} inimene} other {{counter} inimest}} viimase {days, plural, one {päeva} other {{days} päeva}} jooksul",
  "trends.trending_now": "Hetkel populaarne",
  "ui.beforeunload": "Mustand läheb kaotsi, kui lahkud Mastodonist.",
  "units.short.billion": "{count} mld",
  "units.short.million": "{count} mln",
  "units.short.thousand": "{count} tuh",
  "upload_area.title": "Lohista ja aseta üleslaadimiseks",
  "upload_button.label": "Lisa pilte, üks video- või helifail",
  "upload_error.limit": "Faili üleslaadimise piir ületatud.",
  "upload_error.poll": "Küsitlustes pole faili üleslaadimine lubatud.",
  "upload_error.quote": "Tsiteerimisel pole faili üleslaadimine lubatud.",
  "upload_form.drag_and_drop.instructions": "Manuse valimiseks vajuta tühikut või sisestusklahvi. Lohistamise ajal kasuta nooleklahve, et manust liigutada teatud suunas. Vajuta tühikut või enterit uuesti, et paigutada manus oma uuele kohale, või escape tühistamiseks.",
  "upload_form.drag_and_drop.on_drag_cancel": "Lohistamine tühistati. Manus {item} on asetatud.",
  "upload_form.drag_and_drop.on_drag_end": "Manus {item} on asetatud.",
  "upload_form.drag_and_drop.on_drag_over": "Manus {item} on liigutatud.",
  "upload_form.drag_and_drop.on_drag_start": "Tõstetud on manus {item}.",
  "upload_form.edit": "Muuda",
  "upload_progress.label": "Üleslaadimisel...",
  "upload_progress.processing": "Töötlen…",
  "username.taken": "See kasutajanimi on juba kasutusel. Proovi teist",
  "video.close": "Sulge video",
  "video.download": "Laadi fail alla",
  "video.exit_fullscreen": "Välju täisekraanist",
  "video.expand": "Suurenda video",
  "video.fullscreen": "Täisekraan",
  "video.hide": "Peida video",
  "video.mute": "Summuta",
  "video.pause": "Paus",
  "video.play": "Mängi",
  "video.skip_backward": "Keri tagasi",
  "video.skip_forward": "Keri edasi",
  "video.unmute": "Lõpeta summutamine",
  "video.volume_down": "Heli vaiksemaks",
  "video.volume_up": "Heli valjemaks",
  "visibility_modal.button_title": "Muuda nähtavust",
  "visibility_modal.direct_quote_warning.text": "Kui sa need seadistused salvestad, siis lõimitud tsitaat muutub lingiks.",
  "visibility_modal.direct_quote_warning.title": "Tsitaate ei saa privaatse mainimise puhul lõimida",
  "visibility_modal.header": "Nähtavus ja kasutus",
  "visibility_modal.helper.direct_quoting": "Ainult mainituile mõeldud Mastodoni postitusi ei saa teiste poolt tsiteerida.",
  "visibility_modal.helper.privacy_editing": "Nähtavust ei saa peale postituse avaldamist muuta.",
  "visibility_modal.helper.privacy_private_self_quote": "Privaatsete postituste tsiteerimist oma enda poolt pole võimalik teha avalikuks.",
  "visibility_modal.helper.private_quoting": "Ainult jälgijatele mõeldud Mastodoni postitusi ei saa teiste poolt tsiteerida.",
  "visibility_modal.helper.unlisted_quoting": "Kui teised kasutajad sind tsiteerivad, siis nende postitused peidetakse ajajoonelt, mis näitavad populaarsust koguvaid postitusi.",
  "visibility_modal.instructions": "Halda seda, kes võivad antud postitusega suhestuda. Lisaks võid kõikide tulevaste postituste seadistusi muuta valikust <link>Eelistused > Postituse vaikeseadistused</link>.",
  "visibility_modal.privacy_label": "Nähtavus",
  "visibility_modal.quote_followers": "Ainult jälgijad",
  "visibility_modal.quote_label": "Kes võivad tsiteerida",
  "visibility_modal.quote_nobody": "Ainult mina",
  "visibility_modal.quote_public": "Kõik",
  "visibility_modal.save": "Salvesta"
}
